const translationsHe = {
    "status": "success",
    "data": {
        "lang": "he_IL",
        "app": "hotel",
        "translation": {
            "liveBooking": {
  bookingMovedToOperationsMessage:
    'ההזמנה שלך עובדה בהצלחה והועברה לצוות התפעול שלנו לאישור הספק.',
  pleaseWaitSupplierApproval:
    'אנא המתן בזמן שהספק בודק ומאשר את ההזמנה שלך. זה בדרך כלל לוקח כמה שעות.',
  waitingSupplierApproval: 'ממתין לאישור הספק',
  youWillBeNotified:
    'תקבל הודעה בדוא"ל ברגע שהספק יגיב.',
                            "processingYourBooking": "מעבד את ההזמנה שלך...",
            "stepCompletedSuccessfully": "השלב הושלם בהצלחה",
            "somethingWentWrongOurTeamIsWorkingOnIt": "משהו השתבש. הצוות שלנו עובד על זה.",
            "stepCouldNotBeCompleted": "לא ניתן להשלים את השלב.",
            "stillProcessingPleaseWait": "עדיין בעיבוד, אנא המתן...",
            "waitingForSupplierApproval": "ממתין לאישור הספק",
            "stepAlreadyCompleted": "השלב כבר הושלם.",
            "REVALIDATE": "אימות מחדש",
            "RESERVATION": "הזמנה",
            "SUMMARY": "סיכום",
            "PAYMENT_FINALIZATION": "סיום התשלום",
            "bookingProcessStatus": "סטטוס תהליך ההזמנה",
            "order": "הזמנה",
            "lastUpdate": "עדכון אחרון",
            "liveStreamingNotAvailable": "שידור חי אינו זמין — מתבצעת בדיקה מחזורית כחלופה. אם הבעיה נמשכת, צוות התפעול שלנו בודק זאת.",
            "noProgressAvailable": "אין עדיין עדכון על התקדמות ההזמנה.",
            "paymentNotRequired": "לא נדרש תשלום עבור הזמנה זו (נבחרה אפשרות תשלום מאוחר יותר)",
            "paymentProcessed": "התשלום בוצע",
            "transactionId": "מזהה עסקה:",
            "processingOrderLevelJob": "מעבד משימה ברמת ההזמנה",
            "emailSentToCustomer": "האימייל נשלח ללקוח",
            "status": "סטטוס",
            "retries": "ניסיונות חוזרים",
            "eta": "זמן משוער",
            "timestamp": "חותמת זמן",
            "processing": "בעיבוד",
            "currentAttempt": "ניסיון נוכחי",
            "of": "מתוך",
            "failedToProcess": "העיבוד נכשל",
            "supplierApiDidNotRespond": "ממשק ה-API של הספק לא הגיב במסגרת הזמן המותרת.",
            "attempts": "ניסיונות",
            "duration": "משך זמן",
            "failedAt": "נכשל ב־",
            "retryAvailable": "ניתן לנסות שוב",
            "retryStep": "נסה שוב את השלב",
            "waitingForRetry": "ממתין לניסיון חוזר לאחר תקלה זמנית.",
            "etaForRetry": "זמן משוער לניסיון חוזר:",
            "awaitingPreviousStep": "ממתין להשלמת השלב הקודם",
            "paymentWillBeProcessed": "התשלום יעובד בהמשך",
            "emailQueued": "התראת אימייל נכנסה לתור",
            "willBeSentAfterPayment": "יישלח לאחר אישור התשלום",
            "processFailedAtStep": "התהליך נכשל בשלב",
            "processingStep": "מעבד שלב",
            "system": "מערכת",
            "bookingConfirmed": "ההזמנה אושרה!",
            "orderApprovedSuccessfully": "ההזמנה שלך אושרה בהצלחה.",
            "sentItineraryToEmail": "שלחנו את מסלול הנסיעה לאימייל שלך.",
            "orderConfirmed": "ההזמנה אושרה",
            "allSystemsGo": "כל המערכות פועלות!",
            "orderNumber": "מספר הזמנה",
            "confirmation": "אישור",
            "sentToEmail": "נשלח לאימייל",
            "checkYourInbox": "בדוק את תיבת הדואר הנכנס",
            "completeItinerarySent": "מסלול הנסיעה המלא ופרטי ההזמנה נשלחו לכתובת האימייל הרשומה שלך.",
            "orderBeingProcessed": "ההזמנה שלך נמצאת כעת בעיבוד.",
            "orderWaitingForSupplier": "ההזמנה שלך ממתינה כעת לאישור הספק.",
            "errorProcessingStep": "אירעה שגיאה בעיבוד שלב זה.",
            "pending": "ממתין",
            "awaitingProcessing": "ממתין לעיבוד.",
            "skipped": "דולג",
            "stepNotRequired": "שלב זה לא היה נדרש עבור ההזמנה שלך.",
            "completed": "הושלם",
            "processSteps": "שלבי התהליך",
            "stepsCompletedSuccessfully": "השלבים הושלמו בהצלחה",
            "allDone": "הושלם",
            "failed": "נכשל",
            "inProgress": "בתהליך",
            "loadingStatus": "טוען סטטוס",
            "okay": "בסדר",
            "approved": "אושר"
            },

            "crud": {
                "updatedSuccessfully": "עודכן בהצלחה",
                "validationFailed" : "Validation failed",
                "fieldRequired":"שדה נדרש",
                "operationError" : "Error occurred",
                "emptyList" : "No Data Found",
                "failToLoad" : "Error occurred on loading",
                "modelNotFound" : "Not Found",
            },
            "updateCard": {
                "payment_failed_please_update_card": "Payment failed - please update card",
                "open_the_payment_form": "Open the payment form",
            },
            "auth": {
                authTypeWarning: 'אנא פנה לצוות התפעול כדי להפעיל את החברות - סוג האימות לא מוגדר',
                authTitle: "הזדהות באמצעות ת.ז וטלפון נייד",
                pleaseLogin: "אנא התחבר עם פרטי ההזדהות שלך",
                verify: "אמת קוד",
                id: "תעודת זהות",
                idPlaceholder: "הזן את תעודת הזהות שלך",
                idPlaceholderError: "אנא הזן את תעודת הזהות שלך",
                idDigits: "תעודת הזהות חייבת להכיל 9 ספרות",
                phone: "טלפון",
                phonePlaceholderError: "אנא הזן את מספר הטלפון שלך",
                phoneDigits: "מספר הטלפון חייב להכיל 9 ספרות",
                phonePlaceholder: "הזן את מספר הטלפון שלך",
                send: "שלח קוד",
                authModalTitle: "אימות עם תעודת זהות וטלפון נייד",
                loginLoaeder: "מתבצעת כניסה...",
                loginError: "הכניסה נכשלה. אנא נסה שוב.",
                otpLoader: "מאמת קוד חד-פעמי...",
                loginSuccess: "התחברת בהצלחה",
                otpError: "אימות הקוד נכשל. אנא נסה שוב.",
                otpStartOver: "לא קיבלת קוד? התחל מחדש",
                register: "הרשמה",
                firstName: "שם פרטי",
                lastName: "שם משפחה",
                email: "אימייל",
                firstNamePlaceholder: "הזן את שמך הפרטי",
                lastNamePlaceholder: "הזן את שם המשפחה שלך",
                emailPlaceholder: "הזן את כתובת האימייל שלך",
                firstNamePlaceholderError: "אנא הזן את שמך הפרטי",
                lastNamePlaceholderError: "אנא הזן את שם המשפחה שלך",
                emailPlaceholderError: "אנא הזן את כתובת האימייל שלך",
                emailInvalid: "אנא הזן כתובת אימייל תקינה",
                nameMinLength: "השם חייב להכיל לפחות 2 תווים",
                registerButton: "הרשמה",
                backToLogin: "חזרה להתחברות",
                registrationSuccess: "ההרשמה הצליחה",
                registrationSuccessMessage: "ההרשמה שלך הצליחה",
                registrationError: "ההרשמה נכשלה. אנא נסה שוב.",
                dontHaveAccount: "לא יש לך חשבון?",
                registerHere: "הרשמה כאן",
                authWithMobile: "הזדהות עם טלפון נייד",
                registerWithMobile: "הרשמה עם מספר טלפון נייד",
                loginTitle: "התחבר כדי להמשיך",
                loginDescription: "להזמנה או ניהול הזמנה, אנא אמת את מספר הטלפון שלך. זה לוקח פחות מדקה.",
                otpInfo: "נשלח קוד חד-פעמי (OTP). אין צורך בסיסמה.",
                whyLogin: "למה אני צריך להתחבר?",
                newHere: "חדש כאן?",
                createAccount: "צור חשבון",
                sendCode: "שלח קוד",
                privacyNotice: "לעולם לא נשתף את המספר שלך. ייתכן שיחולו תעריפי SMS.",
                mobileNumber: "מספר נייד",
                accountNotFound: "החשבון אינו קיים",
                continueWithRegistration: "האם תרצה להמשיך להרשמה?",
                continueRegistration: "המשך להרשמה",
                cancel: "ביטול",
                registrationStepIndicator: "שלב 2 מתוך 2 — הזן פרטים",
                createYourAccount: "צור את חשבונך",
                registrationDescription: "צור חשבון להשלמת הזמנות במהירות ומעקב אחר ההזמנות שלך.",
                mobileHelper: "נשתמש בזה לשליחת קוד האימות שלך.",
                emailHelper: "אופציונלי — לקבלת שוברים ועדכונים.",
                agreeToTerms: "אני מסכים/ה ל",
                terms: "תנאים",
                and: "ו",
                privacyPolicy: "מדיניות פרטיות",
                alreadyHaveAccount: "כבר יש לך חשבון?",
                logIn: "התחבר",
                agreeToTermsError: "יש לאשר שקראת והסכמת לתנאים ומדיניות פרטיות",
                subscribeNewsletter: "הירשם לניוזלטר שלנו",
                newsletterEmailRequired: "אנא הזן את כתובת האימייל שלך כדי להירשם לניוזלטר",
                updateProfile: "עדכן פרופיל",
                logout: "התנתק",
                updateProfileSuccess: "הפרופיל עודכן",
                updateProfileSuccessMessage: "הפרופיל שלך עודכן בהצלחה.",
                updateProfileError: "עדכון הפרופיל נכשל. נסה שוב.",
                close: "סגור",
            },
            "upgradePlan": {
                "general": {
                    "upgrade_plan": "שדרג עכשיו!",
                    "upgrade_plan_to_regular": "שדרג ל Agent360 ותוכל לקבל גישה לכלל המוצרים - טיסות סדירה, מלונות ואטרקציות!",
                    "upgrade_plan_to_pro": "שדרג לתוכנית PRO קבל אתר משלך, ובנה את העסק בצורה איכותית ומקצועית!",
                  },
                "regular": {
                    "title" : "שדרג עכשיו וקבל גישה למוצרי Agent 360 !",
                    "benefits_title_text": "כרגע אתה מחובר לחבילה Agent 360 Light, במידה ותשדרג תוכל לקבל",
                    "text_1": "מוצרי סיטונאות סקיי 360",
                    "text_2": "מלונות לכל היעדים בעולם",
                    "text_3": "טיסות סדירות ו Low Cost",
                    "text_4": "אטרקציות בכל העולם",
                    "button_text": "שדרג עכשיו ל Agent 360 !",
                },
                "pro": {
                    "title" : "שדרג עכשיו וקבל אתר לעסק שלך עם מיתוג מלא !",
                    "benefits_title_text": "בחבילת SKY 360 Pro תוכל להנות מ",
                    "text_1": "אתר עם דומיין ייחודי שלך ",
                    "text_2": "מיתוג העסק - לוגו וצבעים לאתר ",
                    "text_3": "קידום חבילות וטיסות באתר לפי יעדים ",
                    "text_4": "כל ההזמנות שיסגרו יהיו שייכות לסוכנות שלך!",
                    "button_text": "שדרג עכשיו ל Pro !",
                },
            },
            "contactUs": {
                "requestForQuotation":"בקשה להצעת מחיר",
                "problemWithExistingOrder":"בעיה בהזמנה קיימת",
                "customerService":"שירות לקוחות",
                "other":"אחר",
                "messageReceivedSuccessfully":"ההודעה נשלחה בהצלחה",
                "email": "אימייל",
                "phone": "טלפון",
                "fullName": "שם מלא",
                "writeUsMessage": "כתבו לנו הודעה",
                "send": "שלח",
                "phoneRequired": "נא להזין מספר טלפון",
                "emailRequired": "נא להזין כתובת אימייל",
                "fullNameRequired": "נא להזין שם מלא",
                "messageRequired": "נא להזין הודעה",
                "nameMinLength": "השם חייב להכיל לפחות 2 תווים",
                "emailInvalid": "נא להזין כתובת אימייל תקינה",
                "subjectRequired": "נא לבחור נושא",
                "selectSubject": "בחר נושא",
                "messageMin": "ההודעה חייבת להכיל לפחות 10 תווים",
                "aboutUs":'עלינו'
            },
            "cart": {
                "addToCart": "הוסף לסל",
                "select": "בחר",
                "remove": "הסר",
            },
            "customerSupport": {
                "customerService": "שירות לקוחות",
                "sendMessageAndGetNotified": "שלחו לנו הודעה ונציג יחזור אליכם בהקדם",
                "callUs": "צלצלו אלינו - ",
            },
            "roomInfo": {
                "info": "תאור החדר",
                "viewAllThePhotos": "צפו בכל התמונות",
                "roomSize": "מ״ר - גודל חדר",
                "peopleInTheRoom": "אנשים בחדר",
                "doubleBed": "מיטה זוגית",
                "flights":"טיסות",
            },
            "conceptsList":{
                "conceptsListTitle":"חבילות הנופש שלנו, מהיום רוכשים מלון עם אטרקציות!",
                "includesActivities":"אטרקציות מתנה",
                "includesActivity":"כולל אטרקציה מתנה",
                "includeInPackage":"החבילה כוללת",
                "transfer": "כולל העברות",
                "includesTransfer": "כולל העברות",
                "transferContent":"העברות הלו״ש במחיר החבילה",
                "baseBoard": "בסיס אירוח",
                "autoApprove": "באישור מיידי",
                "airways": "חברת תעופה",
                "flightFrom": "טיסה הלוך",
                "flightBack": "טיסה חזור",
                "toOrder": "להזמנה",
                "nights":"לילות",
                "numberOf": "מספר",
                "noPackagesFound":"לא נמצאו חבילות",
                "moreDeals":"אופציות נוספות",
                "pricePerPerson":"תוספת לאדם",
            },
            "wallet":{
                future: "יהלומים עתידיים",
                creditCard:"כרטיס אשראי",
                cancel: "ביטול",
                forConfirmationRedemption: "האם אתה בטוח שברצונך לממש את היהלומים?",
                TotalDiamondsYouWillReceive: "סך כל היהלומים שייצברו",
                max: "מקסימום",
                currentOrderTotal: "סכום ההזמנה הנוכחית",
                MaximumRedeemable: "מקסימום ניתן למימוש:",
                UseMax: "השתמש במקסימום",
                Apply: "החל",
                Applying: "מוחל...",
                RedeemDiamonds: "ממש יהלומים",
                RemainingDiamonds: "יהלומים שנותרו",
                DiscountedValue: "ערך לאחר הנחה",
                RedeemedAmount: "סכום שמומש",
                Redeemed: "מומש",
                totalValue: "ערך כולל",
                diamondsRate: "1 יהלום = 1 ₪",
                availableDiamonds: "יהלומים זמינים",
                diamondBalance: "יתרת יהלומים",
                discount: "הנחה",
                Subtotal: "סכום ביניים",
                paymentDetails: "תשלום באמצעות",
                totalPayment: "תשלום כולל:",
                "wallet": "ארנק",
                "walletTransactions": "עסקאות ארנק",
                "walletBalance": "יתרת ארנק",
                "diamonds": "יהלומים",
                "diamondsAreAvailableAtYourDisposal": "יהלומים זמינים לרשותך",
                "paymentWithDiamonds": "תשלום ביהלומים",
                "returnToOrderManagement": "חזרה לניהול הזמנות",
                "reserve": "שמירה",
                "finalize": "סיום",
                "release": "שחרור",
                "partialRealization": "מימוש חלקי",
                "fullRealization": "מימוש מלא",
                "selectNumberOfDiamondsForPartialUse": "בחר מספר יהלומים לשימוש חלקי",
                "useAllTheDiamondsIHave": "שימוש בכל היהלומים שיש לי",
                "save": "שמירה",
                "confirm": "אישור",
                "forConfirmation": "לאישור",
                "totalAgentFee": "סך עמלת סוכן",

                "dynamicLabels": {
                    'availableDiamondsForPayment': `יש לך #{amount} יהלומים זמינים לתשלום, בשווי #{price}`,
                    'XOfDiamondsWorthY': `#{amount} יהלומים, בשווי #{price}`,
                    'totalDiamondsYouHaveAccumulatedOverTheLast12MonthsAsOfToday': `סך היהלומים שצברת במהלך 12 החודשים האחרונים נכון להיום`,
                  },
            },
            "viewFlight":{
                "sameRates": "מחירים זהים",
                "pleaseSelectDestinationAirport": "בחר שדה תעופה ",
                "noNearbyAirportFound": "לא נמצא שדה תעופה קרוב. אנא חפש שדה תעופה וודא שהוא נמצא בקרבת המלון",
                "chooseAirportYouWantToArrive": "בחר נקודת מגישה",
                "chooseAirportYouWantToArriveDescription": "נא לבחור נקודת מגישה קרובה למלון",
                "noFlightsForSelectedDatesLocationPassengers": "אין טיסות זמינות לתאריכים/מיקום/נוסעים שנבחרו",
                "updateAirport": "החלף שדה תעופה",
                "flightFrom": "טיסה הלוך",
                "flightChange": "החלף טיסה",
                "totalChange": "סה״כ למחיר חבילה",
                "noFlightsAvailableForSelectedDates": "אין טיסות זמינות לתאריכים שנבחרו, אנא בחר תאריכים אחרים",
                "show_tickets_with_different_fare_combinations": "הצג סוגי כרטיס עם הלוך חזור שונה",
                "ticketFare":"כרטיס",
                "ticketInfo":"פירוט כרטיס",
                "termsAndConditions": "תנאים והגבלות",
                "ifTicketIncludeSeat": "אם הכרטיס כולל מושב - הלקוח יצטרך לבחור אותו באתר חברת התעופה",
                "inCaseOfChange": "במקרה של שינוי - הלקוח יצטרך לשלם תוספת אם הכרטיס המעודכן יקר יותר, כמו כן ישנה עמלת שירות נוספת בהתאם לתנאי האתר והשירותים",
                "inCaseOfCancellation": "במקרה של ביטול - תהיה עמלת שירות נוספת בהתאם לתנאי האתר והשירותים",
                "allFares":"אופציה לבחירת סוג כרטיס",
                "allFaresComment1":"שים לב שבמידה והכרטיס ניתן לשינוי או ביטול - ישנה עלות עבור דמי טיפול - יש לעיין בתקנון",
                "allFaresComment2":"הושבה, בחירת ארוחה ועוד תוספת ניתן לממש רק באתר חברת התעופה לאחר הזמנה",
                "fareChangedSuccessfully":"מחיר הנסיעה השתנה בהצלחה",
                "openFares":"תעריפים פתוחים",
                "selectedFare":"החלף סוג כרטיס ",
                "error4305Title":"אופס, אזלו המקומות לטיסה",
                "error4305Content":`אנו מתנצלים, אך כנראה שנגמרו המקומות להצעה זו ולכן אין באפשרותנו להתקדם לרכישה.
                הנך מועבר לעמוד הראשי.`,
                "TC":"תנאים",
                "flights":"טיסות",
                "title":"הטיסה הנבחרת, ודאו פרטים והמשיכו לתשלום",
                "addBaggage":"הוסף מזוודה",
                "closeAddBaggage":"הסתר אופציות",
                "addTrolly":"הוסף טרולי",
                "somethingWetWrong":"משהו השתבש",
                "suitcasePrice":"מחיר מזוודה",
                "trollyPrice":"מחיר טרולי",
                "totalPerPassenger":"סך הכל לנוסע",
                "search": "חיפש",
                "updatePassengers":"עדכן כמות נוסעים",
                "seating":"הושבה",
                "cancelation":"ביטול כרטיס",
                'meal':"ארוחות",
                'trolly':"תיק יד",
                'suitcase':"מזוודה",
                'changeFlight':"שינוי כרטיס",
                "extension":"תוספת",
                "totalToBePaid":"סה״כ לתשלום",
                "choose":"בחרו",
                "checkAmenities":"לבדוק מתקנים",
                "description":"תיאור",
                "amenityType":"סוג תוספת",
                "fullInfo":"מידע מלא",
                "flightFromAmenities":"טיסה מהשירותים",
                "flightBackAmenities":"שירותי טיסה חזרה",
                "BAGGAGE": "מטען",
                "2 CHECKED BAGS UP TO 32KG EACH": "2 תיקי מטען מסומנים עד 32 ק״ג כל אחד",
                "2 CABIN BAGS UP TO 8KG": "2 תיקי תא הנוסעים עד 8 ק״ג",
                "BRANDED_FARES": "כרטיסים ממותגים",
                "STANDARD SEAT RESERVATION": "הזמנת מושב סטנדרטי",
                "MILEAGE ACCRUAL": "צבירת נקודות",
                "MEAL": "ארוחה",
                "SNACK": "חטיף",
                "COMPLIMENTARY FOOD AND BEV": "אוכל ושתייה ללא תשלום",
                "ENTERTAINMENT": "בידור",
                "MAGAZINES / NEWSPAPER": "מגזינים / עיתונים",
                "LOUNGE": "טרקלין",
                "LOUNGE ACCESS": "גישה לטרקלין",
                "TRAVEL_SERVICES": "שירותי נסיעות",
                "PRIORITY BAGGAGE": "תיקי עדיפות",
                "PRIORITY CHECK IN": "מעבר מהיר צ'ק אין",
                "PRIORITY SECURITY": "מעבר מהיר ביטחון",
                "PRIORITY BOARDING": "מעבר מהיר עלייה למטוס",
                "IN FLIGHT ENTERTAINMENT": "בידור בטיסה",
                "CHANGEABLE TICKET": "שינוי כרטיס",
                "BASIC SEAT": "מושב בסיסי",
                "PRE_RESERVED_SEAT": "מושב שמור מראש",
                "PRIVACY SEAT BUSINESS CLASS": "מושב פרטיות מחלקת עסקים",
                "CHANGE BEFORE DEPARTURE": "שינוי לפני היציאה",
                "CHANGE AFTER DEPARTURE": "שינוי לאחר היציאה",
                "REFUND BEFORE DEPARTURE": "החזר לפני היציאה",
                "REFUND AFTER DEPARTURE": "החזר לאחר היציאה"

            },
            "room": {
                "roomSize": "גודל החדר",
                "bedType": "סוג מיטה",
                "breakfastIncluded": "כולל ארוחת בוקר",
                "noAvailabilityOnSelectedDates": "אין זמינות לחדר זה בתאריכים הנבחרים"
            },
            "promotion": {
                "modelNotFound": "דף לא נמצא",
                "failToLoad": "לא הצלחנו לטעון את העמוד!",
            },
            "searchDatePicker": {
                "showingAllResultsWithin": "הצג את כל התוצאות במרחק של",
                startFrom: "החל מ-",
                'PARTICIPANTS': 'משתתפים',
                'CITY': 'עיר',
                'COUNTRY': 'מדינה',
                'EVENT_TYPE': 'סוג אירוע',
                'TOURNAMENTS': 'טורנירים',
                'VENUES': 'מיקומים',
                "events":"ספורט והופעות",
                "sportsAndEvents":"ספורט והופעות",
                checking: "בדיקה",
                providers: "מספקים",
                keepScanning: "לחפש",
                validatePricesInRealTime: "לאמת מחירים בזמן אמת",
                foundSoFar: "נמצא עד כה",
                return: "חזרה",
                calendar: "לוח שנה",
                cubes: "קוביות",
                requiredFields: "אנא מלאו את כל השדות הנדרשים: יעד, יציאה ותאריכים כדי להציג את התוצאות.",
                otherDeparture:"בחר יציאה אחרת",
                departure: "יציאה",
                "freeCancellationTooltipText": "הביטול החופשי תקף רק לחדרי המלון",
                "dynamicPackages": "טיסה + מלון באישור מיידי!",
                "includeEvents": "כלול אירועים",
                "includeFullPackage": "כלול חבילה מלאה",
                "package_hotel_flight": "חבילה (טיסה + מלון)",
                "package_hotel_flight_events": "חבילה (טיסה + מלון + אירועים)",
                "hotel_plus_flight": "מלון + טיסה",
                "hotel_plus_flight_events": "מלון + טיסה + אירועים",
                "searchHotelsByNameTitle": "חיפוש לפי שם מלון ליעד שנבחר",
                "choose_packages_according_to": "חבילות לפי סוג",
                "tech_stops": "עצירות טכניות",
                "freePlanFlightSearchFooterText": "החבילה החינמית מאפשרת לחפש טיסות צ׳רטר בלבד! מעוניין בטיסות סדירות לכל העולם",
                "clickHere": "לחץ כאן",
                "approveSelection": "אישר נוסעים",
                "attractions":"אטרקציות",
                "attractions_type":"סוגי אטרקציות",
                "room":"חדר",
                "mapView": "הצג תוצאות במפה",
                'addRoom':"הוסף חדר",
                "removeRoom":'להסיר חדר',
                "needAnotherRoomAddToCart": "חדר נוסף? פשוט הוסיפו לסל",
                "indirectFlight": "עם עצירות",
                "directFlightLabel": "טיסות ישירות",
                "city": "City",
                "hotel": "Hotel",
                "searchForDestination":"חפש יעד",
                "searchByDestinationAndHotel": "בחר יעד או מלון ",
                "searchHotelOrDestination": "חפש מלון או יעד",
                "noResultsForThisDate":"לא נמצא חבילות לתאריך זה",
                "searchDestination":"חפש יעד",
                "pleaseSelectDestination":"אנא בחר יעד",
                "airlineInformation":"מידע על חברת התעופה",
                "airlineCode":"קוד",
                "title":"הזמינו את חופשת החלומות שלכם",
                "hotelOnly":"חיפוש חופשה בתאריכים",
                "hotelWithFlight":"חיפוש חופשה כולל טיסה",
                "oneWay":"כיוון אחד",
                "roundTrip":"הלוך ושוב",
                "selectDate":"בחרו תאריכים",
                "startDate":"תאריך התחלה",
                "endDate":"תאריך סיום",
                "flights":"חיפוש טיסות",
                "packages":"חבילות נופש",
                "hotels":"מלונות בחול",
                "israelPackage":"חופשה בארץ",
                "specialPackage":"חבילות מיוחדות",
                "passengers":"נוסעים",
                "adults":"מבוגרים",
                "adult":"מבוגר",
                "child":"ילד",
                "children":"ילדים",
                "infant":"תינוק",
                "infants":"תינוקות",
                "infantsWarningMessage":"תינוק צריך להיות פחות משנתיים מיום הטיסה הלוך וחזור",
                "select":"בחר",
                "noResults":"אין תוצאות",
                "checkout":"בצע הזמנה",
                "regularPrice":"מחיר רגיל",
                "from":"מ",
                "purchase":"לִרְכּוֹשׁ",
                "selectNewFlight":"בחר טיסה חדשה",
                "search": "חיפוש",
                "rooms": "חדרים",
                "composition": "הרכבים",
                "chooseComposition": "בחרו הרכבים",
                "numberOfGuests": "כמות אורחים",
                "checkOut": "צ׳ק אאוט",
                "checkIn": "צ׳ק אין",
                "whatVacation": "איזה חופשה",
                "youWant": "אתם רוצים",
                "vacationFriendsWith": "חופשה  חברים עם",
                "familyVacation": "חופשה משפחתית",
                "romanticVacation": "חופשה רומנטית",
                "notAvailable": "אין זמינות",
                "roomAvailableDuringTheWeek": "זמינות חדרים במהלך השבוע",
                "followingDates": "תאריכים הבאים",
                "vacation":"חופשה",
                "abroad":"בחו״ל",
                "inIsrael":"בארץ",
                "destination":"כל היעדים",
                "chooseDestination":"בחרו יעדים",
                "findDreamVacation":"חפשו את החופשה המושלמת בקליק.",
                "searchResTitle":"בחרו את החבילה המתאימה עבורכם",
                "directFlight":"טיסה ישירה ",
                "stop_1": "עצירה אחת",
                "stops": "עצירות",
                "activeFlight":"הטיסה מופעלת",
                "flightSearch":"חיפוש טיסה",
                "nights":"לילות",
                "until":"עד תאריך",
                "date":"תאריך",
                "untilYouSearchForFlightDate":"עד חיפוש טיסות תאריך",
                "destinationFrom":"המראה",
                "packageSearch":"חיפוש חבילה",
                "destinationTo":"נחיתה",
                "selectDestination":"בחר יעד",
                "checkHotel":"מעבר להזמנה",
                "noRating": "ללא דירוג",
                "toOrder":"להזמנה",
                "selectAgain": "בחר מחדש",
                "selectFlight": "בחר טיסה",
                "reselectFlight": "בחר טיסות מחדש",
                "flightCanBeReSelectedNextPage": "יהיה ניתן להחליף טיסה בהעמוד החבילה",
                "flightSelectedSuccessfully": "טיסה נבחרה בהצלחה",

                "dynamicFlight":"בחרו את הטיסות בעצמכם",
                "bundle": "טיסות מוגדרות מראש",
                "freeCancelation":"ביטול חופשי",
                "trollyIsIncluded":"טרולי כלול",
                "trollyIsNotIncluded":"ללא טרולי",
                "suitcaseIsIncluded":"מזוודה כלולה",
                "suitcaseIsNotIncluded":"ללא מזוודה",

                "partially_operated_by_airlines": "מופעלת חלקית ע״י",
                "operated_by_airlines": "מופעלת ע״י",
                "connect_in_airport": "עצירה בשדה ",
                "arrives": "הגעה",
                "journey_duration": "משך המסלול",
                "short_wait": "עצירה קצרה",
                "long_wait": "עצירה ארוכה",
                "flight_number": "מספר טיסה",
            },
            "specialDeal": {
                "closeTheDeal": "סגרו את הדיל ›",
                "endsIn": "מסתיים בעוד",
                "specialDealForTheWeekend": "דיל מיוחד לסופ״ש",
                "from": "מתאריך",
                "until": "עד תאריך"
            },
            "footer": {
                "backToTop": "חזור למעלה",
                "allRightsReserved": " © כל הזכויות שמורות, אין להעתיק תוכן מהאתר ללא רשות.",
                "developBy": "by SKY 360 Technology",
                "thePurchaseOnTheWebsiteIsSecure": "הרכישה באתר מאובטחת.",
                "talkToUs": "איך מדברים איתנו?",
                "address": "כתובת",
                "phone": "טלפון",
                "whatsapp": "וואטסאפ",
                "phoneAndWhatsapp": "טלפון או בוואטסאפ",
            },
            "newsletter": {
                "title": "הירשמו לניוזלטר שלנו",
                "subtitle": "קבלו גישה מוקדמת למבצעים והמלצות ליעדים",
                "placeholder": "השאירו מייל וקבלו גישה לדילים לפני כולם",
                "subscribe": "הירשמו",
                "pleaseEnterEmail": "אנא הזינו כתובת אימייל",
                "somethingWentWrong": "משהו השתבש. נסו שוב."
            },
            "attractionQuestions": {
                "customerInfo": "פרטי המזמיו",
                "participantsInfo": "פרטי אורח",
                "first_name": "שם פרטי",
                "last_name": "שם משפחה",
                "email_address": "אימייל",
                "phone_number": "מס טלפון",
                "pickup_location": "כתובת איסוף",
                "height_in_centimeters": "גובה בסנטימטר",
                "weight_in_kilograms": "משקל בק״ג",
            },
            "attractions":{
                "showingMoreResults": "מציג תוצאות נוספות",
                "noMoreResults": "אין יותר תוצאות",
                "NoResultsMatchedTheFilterValues": "אין תוצאות תואמות לערכי הסינון",
                "inclusions": "כלול",
                "exclusions": "לא כלול",
                "overviewOfTheTrip.":"סקירה כללית על הטיול",
                "immediateConfirmation":"אישור מיידי!",
                "pricePerPerson": "מחיר לאדם",
                "totalForXXXPeople":"סה״כ ל-XXX אנשים",
                "toOrder":"להזמנה",
                "freeCancelation":"הזמינו עכשיו עם ביטול בחינם!",
                "showAll":"פתח הכל",
                "days": "ימים",
                "rating": "דירוג",
                "supplier": "ספק האטרקציה",
                "location": "מיקום",
                "pricePerPersonFrom": "מחיר לאדם החל מ-",
                "selectDatesAndTravelers": "בחרו תאריכים וכמות ומטיילים",
                "bookNowWithFreeCancellation": "הזמינו עכשיו עם ביטול בחינם!",
                "updateSearch": "עדכון חיפוש",
                
                'activities-health-wellness-spas': 'ספא',
                'activities-action-entertainment-shows-events': 'הצגות ואירועים',
                'activities-nature-outdoors-zoos-aquariums': 'גני חיות ואקווריומים',
                'activities-food-drink': 'אוכל ושתייה',
                'activities-action-entertainment-shopping': 'קניות',
                'activities-nature-outdoors-tickets-passes': 'כרטיסים ומעברים',
                'activities-action-entertainment-rentals-rides': 'השכרות ונסיעות',
                'activities-transportation': 'תחבורה',
                'activities-culture-shows-events': 'הצגות ואירועים',
                'activities-nature-outdoors': 'טבע ושטח פתוח',
                'activities-tours-by-theme-shopping-tours': 'סיורי קניות',
                'activities-workshops-classes-sport-lessons': 'שיעורי ספורט',
                'activities-action-entertainment-tickets-passes': 'כרטיסים ומעברים',
                'activities-workshops-classes-music-dance': 'מוזיקה וריקוד',
                'activities-food-drink-workshops-classes': 'סדנאות ושיעורים',
                'activities-health-wellness-relaxation': 'הרפיה',
                'activities-tours-by-theme-food-drink-tours': 'סיורי אוכל ושתייה',
                'activities-workshops-classes': 'סדנאות ושיעורים',
                'activities-health-wellness-beauty-treatments': 'טיפולי יופי',
                'activities-action-entertainment-water': 'מים',
                'activities-workshops-classes-arts-crafts': 'אמנות ומלאכת יד',
                'activities-tours-by-theme': 'סיורים לפי נושא',
                'activities-action-entertainment-land': 'יבשה',
                'activities-tours-by-theme-sport-tours': 'סיורי ספורט',
                'activities-culture': 'תרבות',
                'activities-tours-by-theme-walking-tours': 'סיורי הליכה',
                'activities-health-wellness-alternative-medicine': 'רפואה אלטרנטיבית',
                'activities-tours-by-theme-art-culture-tours': 'סיורי אמנות ותרבות',
                'activities-workshops-classes-cultural-immersion': 'הטמעה תרבותית',
                'activities-health-wellness': 'בריאות ורווחה',
                'activities-nature-outdoors-air-activities': 'פעילויות אוויריות',
                'activities-tours-by-theme-luxury-tours': 'סיורי יוקרה',
                'activities-tours-by-theme-historical-heritage-tours': 'סיורי מורשת היסטוריים',
                'activities-culture-art-culture-tours': 'סיורי אמנות ותרבות',
                'activities-action-entertainment-air': 'אוויר',
                'activities-tours-by-theme-nature-wildlife-tours': 'סיורי טבע וחיות בר',
                'activities-tours-by-theme-discovery-tours': 'סיורי גילוי',
                'activities-nature-outdoors-wildlife-nature-observation': 'תצפיות טבע וחיות בר',
                'activities-action-entertainment': 'פעולה ובידור',
                'activities-tours-by-theme-museum-exhibition-tours': 'סיורי מוזיאון ותערוכות',
                'activities-workshops-classes-food-drink': 'אוכל ושתייה',
                'activities-tours-by-theme-virtual-tours': 'סיורים וירטואליים',
                'activities-tours-by-theme-special-tours': 'סיורים מיוחדים',
                'activities-nature-outdoors-land-activities': 'פעילויות שטח',
                'activities-transportation-rentals-rides': 'השכרות ונסיעות',
                'activities-nature-outdoors-water-activities': 'פעילויות מים',
                'activities-food-drink-restaurants-bars': 'מסעדות ובר',
                'activities-food-drink-food-drink-tours': 'סיורי אוכל ושתייה',
                'activities-no-category': 'ללא קטגוריה',
                'activities-health-wellness-retreats': 'ריטריטים',
                'activities-action-entertainment-sport-lessons': 'שיעורי ספורט',
                'activities-tours-by-theme-self-guided-tours': 'סיורים עצמאיים',
                'activities-action-entertainment-multi-adventure-games': 'משחקי הרפתקה מרובה',
                'activities-food-drink-tickets-passes': 'כרטיסים ומעברים',
                'activities-tours-by-theme-night-tours': 'סיורי לילה',
                'activities-culture-tickets-passes': 'כרטיסים ומעברים',
                'activities-transportation-transfers': 'העברות',
                "hours":"שעות",

                ages_between_min_max_range: `Ages Between {min_max_range}}`,
                sum_price_amount: `Sum Price: {amount}`,
            },
            "sportsAndEvents": {
                "atLeastOneTicketMustBeSelected": "יש לבחור בכפולות כרטיסים",
                "dateNotFinal": "תאריך לא סופי",
                "timeNotFinal": "שעה לא סופית",
                "dateAndTimeNotFinal": "תאריך ושעה לא סופיים",
                "dateIsSubjectToChange": "תאריך עלול להשתנות",
                "timeIsSubjectToChange": "שעה עלולה להשתנות",
                "dateAndTimeAreSubjectToChange": "תאריך ושעה עלולים להשתנות",
                "onlyAFewTicketsLeft": "רק כמה כרטיסים נותרו",
                "pricePerTicket": "מחיר לכרטיס",
                "totalPrice": "מחיר כולל",
                "cannotChangeSeatingFromThisPage": "לא ניתן לשנות את הסידור הישיבה מפה",
                "reselectSeating": "איפוס סידור הישיבה",
                "sportsAndEvents": "ספורט והופעות",
                "noTitle": "אירוע",
                "comingSoon": "בקרוב!",
                "noTicketsAvailable": "אין כרטיסים זמינים",
                "selectTickets": "בחר כרטיסים",
                "notifyMe": "הודע לי",
                "notifyMeDescription": "הזן את כתובת האימייל שלך כדי לקבל התראה כאשר כרטיסים יהיו זמינים",
                "notifyMeEmailPlaceholder": "הזן את כתובת האימייל שלך",
                "notifyMeSubmit": "הודע לי",
                "notifyMeSuccess": "תקבל התראה כאשר כרטיסים יהיו זמינים",
                "notifyMeError": "שליחת ההתראה נכשלה. אנא נסה שוב.",
                "notifyMeEmailRequired": "אנא הזן את כתובת האימייל שלך",
                "notifyMeEmailInvalid": "אנא הזן כתובת אימייל תקינה",
                "tournament": "טורניר",
                "participants": "משתתפים",
                "eventType": "סוג אירוע",
                "vipPackage": "חבילת VIP",
                "hold24Hours": "שמירה ל-24 שעות",
                "instantConfirmation": "אישור מיידי",
                "offlineStock": "מלאי לא מקוון",
                "rating": "דירוג",
                "location": "מיקום",
                "dateTimeSeparator": " ב־",
                "viewOnMap": "הצג במפה",
                "selectQuantity": "בחר כמות",
                "avenue": "שדרה",
                "venue": "מקום",
                "city": "עיר",
                "country": "מדינה",
                "state": "מדינה",
                "zip": "מיקוד",
                "latitude": "קו רוחב",
                "longitude": "קו אורך",
                "whereWillISit": "איפה אשב?",
                "seatingArrangements": "סידורי הישיבה",
                "seatingInPairs": "ישיבה בזוגות",
                "seatingInPairsDescription": "אנו מתחייבים לשבת אתכם בזוגות (שניים ביחד) אלא אם קטגוריית הכרטיס מציינת אחרת.",
                "seatingInPairsNote": "שימו לב: באצטדיונים מסוימים (בעיקר קאמפ נואו של ברצלונה וסנטיאגו ברנבאו של ריאל מדריד) \"ישיבה בזוגות\" כוללת מושבים צמודים באלכסון או בניצב.",
                "seatingThreeTogether": "ישיבה של שלושה ביחד או יותר",
                "seatingThreeTogetherDescription": "כאשר אתה צריך שלושה כרטיסים או יותר נעשה כמיטב יכולתנו להושיב אתכם ביחד; עם זאת, איננו יכולים להבטיח זאת.",
                "seatingThreeTogetherNote": "אם אתם חייבים לשבת ביחד, אנא בדקו זמינות עם צוות שירות הלקוחות שלנו, בטלפון או בדוא״ל. ברוב המקרים נוכל לאשר בקשה ספציפית או להציע פתרון חלופי.",
                "homeFansOrAwayFans": "אוהדי הבית או האורחים",
                "homeFansDescription": "כל הכרטיסים הם למחלקת הבית, אלא אם צוין אחרת (\"מחלקת האורחים\").",
                "homeFansBehaviorCode": "על פי קודי ההתנהגות של המארגן, אסור לכם לעודד את קבוצת האורחים או ללבוש צבעי קבוצת אורחים. מומלץ גם למשתתפים ללבוש בגדים בצבעים ניטרליים אם אינם תומכים בקבוצת הבית. אי ציות לכללים אלה עשוי להתפרש כפרובוקציה ועלול להוביל לגירוש מהאצטדיון.",
                "neutralVenueNote": "המפרטים לעיל אינם חלים על משחקים שמשוחקים באצטדיון ניטרלי (כמו גמר ליגת האלופות, גמר הליגה האירופית, גמר גביע האנגלי, גמר גביע הליגה או אירועי גביע העולם). אלא אם צוין אחרת, המושבים יכולים להיות ממוקמים באחד מהמקטעים, ולכן מומלץ ללבוש בגדים בצבעים ניטרליים.",
                "singleTickets": "כרטיסים בודדים",
                "singleTicketsDescription": "לפעמים אנו מציעים כרטיסים המסווגים במיוחד כ\"בודדים\".",
                "singleTicketsNote": "כרטיסים אלה הם בדרך כלל זולים יותר, אבל הם מה שהם - בודדים. אם תקנו שני כרטיסים \"בודדים\" לא תשבו ביחד.",
                "groupSeating": "ישיבה קבוצתית",
                "groupSeatingDescription": "עבור 8 כרטיסים או יותר אנא בדקו את הזמינות עבור ישיבה קבוצתית והמחיר עם צוות שירות הלקוחות שלנו, בטלפון או בדוא״ל. ישיבה קבוצתית עשויה להיות זולה יותר או יקרה יותר, בהתאם לזמינות.",
                "groupSeatingNote": "אם קטגוריית הכרטיסים שבחרת מאפשרת זאת - אתה יכול להמשיך ולבצע את ההזמנה מבלי לפנות אלינו תחילה, אך זכור, במקרה כזה נוכל להבטיח רק ישיבה בזוגות.",
                "pleaseNote": "שימו לב",
                "pleaseNoteDescription": "המידע לעיל על סידורי הישיבה הוא כללי ובדרך כלל עשוי שלא להתאים לתיאור המדויק של הכרטיס שבחרת. כאשר זמין, אנו מציגים את תרשים הישיבה הרלוונטי או מפת המקום.",
                "pleaseNoteConsult": "אנא התייעץ בו בעת בדיקת קטגוריות הכרטיסים לאירוע זה.",
                "haveMoreQuestions": "יש עוד שאלות?",
                "contactUsForInfo": "למידע נוסף אנא אל תהסס ליצור עמנו קשר",
                "eventLoadError": "טעינת פרטי האירוע נכשלה",
                "quantity": "כמות",
                "deliveryMethod": "שיטת משלוח",
                "selectDeliveryMethod": "בחר שיטת משלוח",
                "ticketsAvailable": "כרטיסים זמינים",
                "available": "זמין",
                "quantityCannotBeZero": "הכמות לא יכולה להיות 0",
                "deliveryMethodNotFound": "שיטת המשלוח לא נמצאה",
            },
            "packages": {
                "tour": "טיול מאורגן",

                "availableSeats":"כיסאות פנויים",
                "isRoundTrip":"מחיר מזוודה לטיסה הלוך חזור * ",
                "from": "מתאריך",
                "until": "עד תאריך",
                "breakfastIncluded": "כולל ארוחת בוקר",
                "includesMassageAndSpa": "כולל מסאג׳ וספא!",
                "lastRoom": "חדר אחרון!",
                "includesTransfers": "כולל העברות",
                "includesFlights": "כולל טיסות",
                "includesEventTicket": "כולל כרטיס לאירוע",
                "includesActivities": "כולל אטרקציות",
                "nights": "לילות",
                "withoutBaggage":"ללא כבודה",
                "directFlight":"טיסה ישירה",
                "oneStop":"עצירה אחת",
                "numOfStops":"עצירות",
                "flightDetails":"פרטי הטיסות",
                "flightFrom":" from -> to ",
                "flightBack":" from -> to ",
                "hours":"שעות",
                "flightNumber":"מס׳ הטיסה",
                "returnFlight":"טיסה חזור",
                "outboundFlight":"טיסה הלוך",
                "airLine":"חברת התעופה",
                "suitcaseWeight":" הטיסה כוללת מזוודה weight ק״ג",
                "trollyWeight":"  הטיסה כוללת טרולי weight ק״ג",
                "trollyWeight2":"weight ק״ג טרולי / תיק",
                "suitcaseWeight2":"weight ק״ג מזוודה",
                "included":"כלול",
                "notIncluded":"לא כלול",
                "perPax":"לאדם",
                "addSuitcaseLater":"ניתן להוסיף כבודה בסל המוצרים - ניהול כבודה",
                "includedActivitiesTitle":"אטרקציות וטיולים בחבילה",
                "checkAllPictures":"הצג את כל התמונות",
                "affiliateWith": "בשיתוף עם",
                "addButtonDisabledTooltip": "הזמנה מוגבלת לכמות חדרים - לא ניתן להוסיף חדר נוסף. כדי לשנות חדר יש להסיר חדר מהעגלה",
                'holidaySchedule':"לו״ז הנופש",
                "passengers":"נוסעים",
                "clickForDetails":"לחצו כאן לפרטי האטרקציה",
                "includedInPackage":"כלול בחבילה!",
            },
            "roomPricing": {
                "noRoomsAvailableForSelectedDates": "אין חדרים זמינים לתאריכים שנבחרו, אנא בחר תאריכים אחרים",
                "noRoomsAvailable": "אין חדרים זמינים לתאריכים ולאורחים שנבחרו.",
                "for": "ל",
                "addPassenger": "הוסף נוסע",
                "autoApprove": "באישור מידי",
                "pricePerPerson": "מחיר לאדם",
                "pricePerRoom": "מחיר לחדר",
                "priceForAllRooms": "מחיר לכל החדרים",
                "payOnSpot": "לתשלום במקום",
                "resort_fee": "מס תייר",
                "occupancy_tax": "מס לינה",
                "totalPrice": "מחיר לחדר ",
                "pricePerInfant": "מחיר לתינוק",
                "composition": "הרכב",
                "adultsInTheRoom": "מבוגרים",
                "children": "ילדים",
                "adults":"מבוגרים",
                "single":"מבוגר יחיד",
                "child":"ילד",
                'selectInfantCount':"בחר מרשימה",
                'infant':"תינוק",
                '1infant':"תינוק אחד",
                '2infants':"2 תינוקות",
                'infants':"תינוקות",
                "noInfants":"ללא תינוקות",
                "all_include": "הכל כלול",
                "breakfast":"ארוחת בוקר",
                "activities":"סיור לבחירה",
                "half_board":"חצי פנסיון",
                "half_board_kosher":"חצי פנסיון כשר",
                "full_board" : "פנסיון מלא",
                "sleep_only" : "לינה בלבד",
                "breakfast_kidush" : "א.בוקר וא.ערב שישי",
                "addToCard": "הוסיפו להזמנה",
                "inPackageDates": "בתאריכי החבילה",
                "chooseRoom": "בחרו סוג חדר",
                "nights": "לילות",
                "boardType":"בסיס לינה",
                "filters":"מסננים",
                "freeCancellation": "ביטול חינם",
                "roomInfo": "מאפייני החדר",
                "noAvailableRooms": "אין חדרים זמינים לתאריכים הנבחרים",
                "noAvailableRoomsForDates": "חדר לא זמין בתאריכים הנבחרים",
                "addInfant":"הוספת תינוק",
                "roomFacilities":"מתקני החדר",
                "show_images": "לכל תמונות החדר",

                //// UPDATE IT LATERRR
                "until": "עד",
                "no": "ללא ביטול חינם",
                "vat": "מע״מ",
                "is": "",
                "not": "לא",
                "includedInPrice": "כלול במחיר",
                "city_tax": "מס מקומי",
                "cancellation_policy": "תנאי ביטול",
                "your_local_time": "* זמן מקומי",
                "additional_price_info": "מידע נוסף",
                "policy": {
                    "freeCancallationUntil": "ביטול חינם עד לתאריך",
                    "freeCancallationUntil2": "ביטול חינם עד",
                    "cancallationBeCharged": "דמי ביטול בסך",
                    "ifYouCancelBetween": "במידה ותבטל מתאריך",
                    "ifYouCancelTill": "במידה ותבטל עד תאריך",
                    "ifYouCancelModifiedBetween": "במידה ותבטל או תשנה את ההזמנה לאחר ה ",
                    "cancelFullPrice": "ייגבו דמי ביטול מלאים",
                    "till": "עד",
                    "rateNonRefundable": "מחיר זה הוא עם דמי ביטול מלאים",
                }
            },
            "boards" : {
                "RO": "לינה בלבד",
                "BB": "ארוחת בוקר",
                "HB": "חצי פנסיון",
                "FB": "פנסיון מלא",
                "AI": "הכל כלול",
                "all-inclusive": "הכל כלול",
                "UA": "אולטרה הכל כלול",
                "UI": "אולטרה הכל כלול",
                "UAI": "אולטרה הכל כלול",
                "BF": "ארוחת בוקר בופה",
                "KB": "ארוחת בוקר כשרה",
                "KBB": "ארוחת בוקר כשרה",
                "KHB": "חצי פנסיון כשרה",
                "HKB": "חצי פנסיון כשרה",
                "CB": "ארוחת בוקר קונטיננטלית",
                "AB": "ארוחת בוקר אמריקאית",
                "DR": "ארוחת ערב וחדר",
                "EB": "ארוחת בוקר אנגלית",
                "FT": "פנסיון מלא + טיפולים",
                "F+": "פנסיון מלא פלוס",
                "GA": "ארוחת גלה",
                "H6": "חצי פנסיון + 6 טיפולים",
                "HT": "חצי פנסיון + טיפולים",
                "IB": "ארוחת בוקר ישראלית",
                "KO": "כשר",
                "KS": "ארוחת בוקר כשרה",
                "MI": "הכל כלול מקסימום",
                "RB": "חדר וארוחת בוקר",
                "NN": "ראה את המסלול",
                "SI": "הכל כלול רך",
                "UL": "אולטרה הכל כלול",
                "half_board":"חצי פנסיון",
                "half-board":"חצי פנסיון",
                "half_board_kosher":"חצי פנסיון כשר",
                "full_board" : "פנסיון מלא",
                "full-board" : "פנסיון מלא",
                "sleep_only" : "לינה בלבד",
                "breakfast_kidush" : "א.בוקר וא.ערב שישי",
                "breakfast": "ארוחת בוקר",
                "breakfast-for-2": "ארוחת בוקר לזוג",
                "nomeal": "לינה בלבד",
                "all_include": "הכל כלול",
            },
            "activitiesTranslations": {
                "addToOrder": "הוסיפו להזמנה",
                "passenger": "לנוסע",
                "showMore": "הצג עוד",
                "addAttractionsAndTrips": "הוסיפו אטרקציות וטיולים",
                "doYouWantToAddAttractions":" רוצים להוסיף אטרקציות לחופשה שלכם?",
                "itsTime":"זה הזמן!",
                "pricePerPerson":"מחיר לנוסע",
            },
            "modal": {
                "viewAllImages": "להציג את כל התמונות",
                "galleryTitle": "גלריית תמונות",
                "cancelationTerms": "תנאי ביטול - ",
                "nameOfTheHotel": "פרטי המלון",
                "hotelInfo": "על המלון",
                "hotelWebsite": "קישור לאתר המלון",
                "showMore": "הצג את כל המידע",
                "showLess": "הסתר",
            },
            "manageBaggage":{
                'manageBaggage':"ניהול כבודה",
                "and": "ו",
                "save": "שמור",
                "purchaseIsNotSupported": "לא ניתן להוסיף לטיסה עם ספק זה",
                "baggageIsForBothFlights": "ניתן להוסיף כבודה לטיסה הלוך ושוב",
                "suitcase":"מזוודה",
                'trolly':"טרולי",
                'guest':'נוסע',
            },
            "shoppingCartTranslations":{
                localInventoryAlert:"הזמנה עם חבילה מיוחדת, כרגע לא נתמכת לצפייה - רק לתשלום",
                skyInventory:"מלאי SKY",
                recommendedHotel:"המלון המומלץ",
                recommendedFlight:"הטיסה המומלצת",
                "dynamicPackageTitleRemark": "המחיר כולל טיסה ומלון - כל מוצר מוגדר באופן עצמאי",
                "dynamicPackageTitleRemarkEvents": "המחיר כולל טיסה, מלון ואירוע - כל מוצר מוגדר באופן עצמאי",
                "productIsApproved": "קיבלנו אישור למוצר זה!",
                "productIsNotApproved": "מוצר זה לא אושר",
                "waitingToApprove": "מוצר זה ממתין לאישור",
                "productIsCancelled": "מוצר זה בוטל",
                "orderIsApproved": "ההזמנה אושרה!",
                "orderIsNotApproved": "ההזמנה לא אושרה!",
                "orderBeingProcessed": "ההזמנה נמצאת בתהליך אישור, נא להמתין...",
                "orderIsCancelled": "ההזמנה בוטלה!",

                'attractionPriceDescription': "מחיר כרטיס יכול להשתנות בימים מסוימים, בחירה של סוג כרטיס כמויות ועוד",
                "selectedDate": "תאריך נבחר",
                "selectADate": "בחר תאריך",
                "availableDatesBetween": "תאריכים זמינים בין",
                "Options": "אפשרויות",
                "Text": "טקסט",
                "Ticket type": "סוג כרטיס",
                "Start Time": "שעת התחלה",
                'Guide language': "שפת מדריך",
                "Pick Up Location": "מיקום איסוף",
                "Custom Pick Up Location": "מיקום איסוף מותאם אישית",
                "Drop Off Location": "מיקום הורדה",
                "Custom Drop Off Location": "מיקום הורדה מותאם אישית",
                'manageBaggage':"ניהול כבודה",
                "youCanAddGuestsOnlyUpToTheAvailableSeats":"ניתן להוסיף לסל על פי כמות המקומות הזמינים לטיסה",
                "paxExceedsAuthorizedSeats": "כמות הנוסעים עולה על כמות המקומות שמאושרים למחיר זה - יש לקחת בחשבון שההזמנה תכנס ללא אישור מיידי ושהמחיר יכול להשנות",
                "paxExceedsAvailableSeats": "כמות הנוסעים עולה על כמות המקומות הזמינה - יש לקחת בחשבון שההזמנה תכנס כממתינה לאישור הספק ושהמחיר יכול להשנות",
                "infantAdditionalPrice":"תוספת מחיר תינוק",
                "netPriceWarning":"מחיר נטו, יש להוסיף עמלה!",
                "copyOrderLink":"העתק קישור להזמנה",
                "createOrder":"שמור הצעה",
                "createOrderError":"שמירת ההצעה נכשלה, נסה שנית",
                "updateCommission":"שמור",
                "commissionNotSaved":"עמלה חדשה לא נשמרה, יש ללחץ על שמור",
                "clearCart":"לחץ להסרת הלקוח והמוצרים",
                "assignCustomer":"שיוך לקוח",
                "firstName":"שם פרטי",
                "lastName":"שם משפחה",
                "phone":"טלפון",
                "comment":"תגובה",
                "email":"אימייל",
                "wrongEmailFormat":"פורמט אימייל שגוי",
                "saveCustomer":'שמור לקוח',
                "updateCustomerTitle":"עדכון לקוח",
                "createCustomerTitle":"צור לקוח חדש",
                "asignCustomer":"שיוך לקוח",
                "avgPricePerPerson": "הוסף מחיר ממוצע לנוסע",
                "avgPricePerPersonLine": "מחיר ממוצע לנוסע",
                "totalPaxLabel": "מס׳ נוסעים",
                "sendByWhatsApp":"שלח ב WhatsApp",
                "copyText":"העתק הצעה",
                "copyQuoteTakanonLine": "יש לוודא כי קראתם ואישרתם את התקנון לפני הרכישה\nלינק לתקנון ולתנאי העסקה: {domain}/takanon",
                "copyWithOrgDays":"העתק הצעה עם מסלול ימים",
                "orgItineraryHeader":"מסלול ימים",
                "orgTourPackageLine":"טיול מאורגן ל{destination}, שם הטיול: {tourName}, {nights}, {dateStart} - {dateEnd}",
                "packageToDestinationLine": "חבילת נופש ל-{destination}",
                "sendBySMS":"שלח ב SMS",
                "findQuoteFor":"שלח הצעת מחיר באמצעות",
                "linkIsGive":"הצעה הינה Live ",
                "dates":"תאריכים",
                "hotelName":"שם המלון",
                "flightPrice":"מחיר טיסה",
                "suitcase":"מזוודה",
                'trolly':"טרולי",
                "passengers":"נוסעים",
                "attractionSearchFailed": "חיפוש אטרקציות נכשל",
                "searchOtherForDates": "אין זמינות, אנא חפש תאריכים זמינים אחרים",
                "cannotSearchForThePastDates": "לא ניתן לחפש תאריכים שחלפו",
                "noAvailabilityOnThisDates": "אין זמינות לתאריכים שנבחרו",
                "shoppingCartButtonTooltip":"יש לבחור הרכב ולהוסיף להזמנה",
                "totalPrice":"סה״כ לתשלום",
                "totalAgentComm":"סה״כ עמלת סוכן",
                "proceedToPayment":"המשך לתשלום",
                "placeOrder":"מעבר לרישום",
                "NoHotelWasChosenForTheVacation":" לא נבחר מלון לחופשה",
                "betweenDates":"בין התאריכים",
                "packageInformation":"פרטי החבילה",
                "rooms":"פירוט החדרים",
                "transfers":"העברות",
                "round_trip_transfers": "העברות / שאטלים למלון הלוך ושוב",
                "reg_transfers":"העברות / שאטלים למלון הלוך ושוב",
                "shuttle_transfers":"שאטלים מהגבול למלון וחזור",
                "flights":"טיסות",
                "activities":"אטרקציות",
                "shoppingCart":"סל מוצרים",
                "package":"חבילת נופש",
                "nights":"לילות",
                "inHotel":"במלון",
                "apply":"אישור",
                "promoCode":"קוד קופון",
                "yourShoppingCart":"סל הקניות שלכם",
                "isEmpty":"עדיין ריק...",
                "myVacation":"החופשה שלי",
                "showAll":"הצג הכל »",
                "beforeDiscount": "סה\"כ לפני הנחה -",
                "agentCommission": "עמלת סוכן -",
                "agentCommissionNet": "עמלת סוכן (תשלום נטו) -",
                "discountFromCode": "הנחת קוד -",
                "affiliateWith": "בשיתוף עם -",
                "tpId": "מזהה הזמנה -",
                "chargeTypeFullCC": "תשלום מלא - כולל עמלה",
                "chargeTypeNetCC": "תשלום עבור מחיר נטו",
                "chargeTypeCash": "עסקה במזומן",
                "agentCommissionPrec": "אחוז עמלת סוכן",
                "priceOff": "הנחה",
                "percentageOff": "אחוז הנחה",
                "selectedItems":"פריטים נבחרים",
                "agentOptions":"אופציות סוכן",
                "compareDisableForAgent":"ניתן להשוות מחיר כאשר יש 2 הצעות בעגלה",
                "createNewUser":"צור הצעת מחיר חדשה",
                "comparePrice":"השוואת מחירים",
                "send":"שלח הצעת מחיר",
                "profitPercentageChange": "שינוי אחוז רווח",
                "or":"או",
                "approval":"אישור",
                "profitPerPerson":"רווח לאדם",
                "grossProfitPercentage":"אחוז רווח כולל",
                "grossProfitPercentageInvalidRange":"אחוז הרווח חייב להיות בין 0 ל-99",
                "viewProduct": "לצפייה",
                "actionNotAllowed":"לא ניתן להוסיף מוצר לסל",
                "orderIsAlreadySaved":"ההזמנה שמורה וכעת לא ניתן להוסיף מוצר נוסף",
                "clickToClear":"לחץ לריקון העגלה",
                "roomsByRequestSubjectOfHotelAvailability":"לא ניתן להוסיף חדדר מאותו סוג, נא בחר חדר מסוג אחר",
                "roomApprovalIsSubjectToRoomAvailability":"אישור החדר תלוי בזמינות החדר",
                "unableToAddRoomToSamePackage": "לא ניתן להוסיף אותו חדר לאותה חבילה",
                'roomsByRequestSubjectOfHotelAvailabilityTitle':"הוספת חדר נכשלה",
                "youReachedMaxRooms": "הגעת למספר החדרים המרבי",
                "eventTicketAlreadyAdded": "לא ניתן להוסיף כרטיס מאותו סוג, נא בחר כרטיס מסוג אחר",
                'failedToAddEventTicket':"הוספת כרטיס אירוע נכשלה",
                "eventTicketPaxMismatchTitle": "מספר הכרטיסים והנוסעים אינו תואם",
                "eventTicketPaxMismatch": "מספר כרטיסי האירוע שנבחרו אינו תואם את מספר הנוסעים (טיסה/חדר). אנא עדכן את כמות הכרטיסים או את בחירת החדר.",
                "attractionAlreadyAdded": "Unable to add the same type of attraction, please select a different type of attraction",
                'failedToAddAttraction':"הוספת אטרקציה נכשלה",
                "adult": "מבוגר",
                "child": "ילד",
                "infant": "תינוק",
                "perPerson": "לאדם",
                "perVehicle": "לכלי",
                "group": "קבוצה",
                "family": "משפחה",
                "perEquipment": "לפי ציוד",
                "perBoat": "פר סירה",
                "none": "לא ידוע",
            },
            "checkout":{
                "cityOfBirth": "עיר לידה",
                "nationalityCountryId": "מדינת אזרחות",
                "fill_out_at_least_one_guest_fields": "אנא מלא את כל השדות לפחות לאורח אחד!",
                "addRestOfGuests": "הזן את כל פרטי הנוסעים",
                "hideRestOfGuests": "הסתר נוסעים",
                "addBaggage":"הוספת כבודה",
                "newGuest":"נוסע חדש",
                "selectGuest":"בחר נוסע",
                "chooseExistingGuest":"בחר נוסע קיים",
                "additionalBaggage":"מטען נוסף",
                "free":"חינם",
                "baggageIsForBothFlights":"הוספת כבודה לטיסה הלוך וחזור יחד",
                "additionalBaggageForThisGuest": 'כבודה נרכשה לנוסע זה בתוספת תשלום',
                "orderFailedToLoad":"התרחשה שגיאה בעת טעינת ההצעה",
                "cartNoLongerValid":"העגלה כבר לא תקפה",
                "room": 'חדר',
                "personalInfo":"פרטי הנופשים",
                "paymentDetails":"פרטי התשלום",
                "orderCompletion":"סיום הזמנה",
                "userDetails":"פרטי המזמין",
                "name":"שם פרטי",
                "lastName":"שם משפחה",
                "passport":"מס׳ דרכון",
                "inEnglish":"באנגלית",
                "birthdate":"תאריך לידה",
                "phone":"טלפון",
                "email":"דוא״ל",
                "notesForTheOrder":"הערות להזמנה",
                "namesOfGuests":"שמות הנוסעים",
                "namesMustMatchPassport":"* יש להקליד את כל השמות באנגלית בדיוק כפי שמופיעים בדרכון",
                "goToPayments":'שליחה ומעבר לתשלום',
                "saveAndCommit": "שמור ואשר להצעה",
                "saveAndPayLater": "שמור ושלם מאוחר יותר",
                "saveOrder":'שמור הזמנה',
                "agreement":"אני מאשר/ת תקנון האתר, תנאי ההזמנה ואת תנאי ביטול ההזמנה",
                "men":"זכר",
                "women":"נקבה",
                "pleaseInputYourPhone":"נא להזין מספר טלפון",
                "pleaseInputYourLastName":"נא להזין שם המשפחה",
                'pleaseInputYourFirstName':"נא להזין את שמך הפרטי",
                "pleaseInputYourEmail":"נא להזין את המייל",
                "pleaseInputYourPassportNumber":"אנא הזן את מספר הדרכון שלך",
                "pleaseInputYourDateOfBirth":"נא להזין תאריך הלידה",
                "pleaseSelectGender":"נא לבחור מין",
                "maxChildAge":"ילד בין הגילאים 2-",
                "maxInfantAge":"תינוקות חייבים להיות מתחת לגיל שנתיים במועד החופשה",
                'pleaseAgreeWithT&C':"נא להסכים לתנאי השימוש ותקנון האתר",
                'viewTerms':"לצפיה בתקנון",
                "invalidEmail":"אימייל שגוי",
                "orderCreateSuccess": "הזמנתך נשמרה בהצלחה, הנך מועבר לתשלום",
                "orderCreateFree": "הזמנתך נשמרה בהצלחה!",
                "orderUpdateSuccess": "הזמנתך עודכנה בהצלחה!",
                "mainRoomGuestTitle" :"חדר על שם",
                "uploadPassportImage":"העלאת צילום דרכון",
                "addInfant":"הוסף תינוק",
                "updateInfant": "עדכון כמות תינוקות",
                "howManyInfantsDoYouWantToAdd":"בחר את כמות התינוקות לחדר זה",
                "add":"לְהוֹסִיף",
                "setInfantCountForRoom": "עדכן כמות תינוקות",
                "setInfantCountForRoomSuccess": "כמות התינוקות עודכנה בהצלחה",
                "infantsAddedToTheRoom":"תינוקות שנוספו לחדר",
                "selectNumberOfInfants":"בחר מספר תינוקות",
                "pricePerInfant":"מחיר לתינוק",
                "infantsRemoved":"הוסרו התינוקות לחדר זה",
                "requiredUploadPassportImage":"חובה להעלאת צילום דרכון",
                "infantError4403":"לא ניתן לשנות כמות תינוקות - צור קשר עם מוקד השירות",
                "docketId":"* Docket ID",
                "agencyId":"* Agency ID",
                "documentType": "סוג מסמך",
                "documentTypeInfo": "בחר תעודת זהות לטיסות פנים",
                "documentTypePassport": "דרכון",
                "documentTypeIdCard": "תעודת זהות",
                "issuingCountry": "מדינת הנפקה",
                "residenceCountry": "מדינת מגורים",
                "nationality": "אזרחות",
                "documentNumber": "מספר מסמך",
                "documentNumberPassport": "מספר דרכון",
                "documentNumberIdCard": "מספר תעודת זהות",
                "pleaseInputPassportNumber": "אנא הזן מספר דרכון",
                "pleaseInputIdCardNumber": "אנא הזן מספר תעודת זהות",
                "expirationDate": "תאריך תפוגה",
                "pleaseSelectDocumentType": "אנא בחר סוג מסמך",
                "pleaseSelectIssuingCountry": "אנא בחר מדינת הנפקה",
                "pleaseSelectResidenceCountry": "אנא בחר מדינת מגורים",
                "pleaseSelectNationality": "אנא בחר אזרחות",
                "pleaseInputDocumentNumber": "אנא הזן מספר מסמך",
                "pleaseSelectExpirationDate": "אנא בחר תאריך תפוגה",
                "noTrolly":"בלי טרולי",
                "noSuitcase":"ללא מזוודה",
                "updateBaggages":"עדכון מזוודות",
                "manageBaggagesFor":"נהל מזוודות עבור אורח",
                "closeAddBaggage":"הסתר אופציות",
                "close":"סגור"
            },
            "manageOrder": {
                moveToPaymentWarning: 'פרטי הלקוח לא נשמרו ופרטי האורחים ריקים! האם אתה בטוח שברצונך להמשיך?',
                moveToPaymentWarning1: 'פרטי הלקוח לא נשמרו. האם אתה בטוח שברצונך להמשיך?',
                moveToPaymentWarning2: 'פרטי האורחים ריקים! האם אתה בטוח שברצונך לעבור לתשלום?',
                "moveToPayment": "הוסף אמצעי תשלום",
                "backToManage": "חזור לניהול הזמנה",
                "paymentTitle": "הוספת אמצעי תשלום",
                "manageTitle": "עדכון פרטי הנופשים",
                "modelNotFound": "הזמנה  לא נמצאה",
                "failToLoad": "לא הצלחנו לטעון את פרטי ההזמנה, אנא נסה שוב מאוחר יותר.",
                "orderId":"ניהול הזמנה",

                "room_booking_cancelled_successfully": "הזמנת החדר בוטלה בהצלחה",
                "room_booking_cancel_error": "שגיאה בביטול הזמנת החדר",
                "cancel_room_booking_warning": "בביטול החדר תאבד את ההזמנה והמחיר, האם אתה בטוח?",
                "cancel_booking": "בטל הזמנה",
                "incompleteDPsWereRemoved": 'חבילות דינמיות לא שלמות הוסרו מהעגלה שלך. אנא הוסף אותן שוב עם גם מלון+טיסה וגם כרטיסי ספורט והופעות.',
            },
            "completionForm": {
                "paymentFinish": {
                    "title": "ההזמנה בוצעה בהצלחה - התשלום הושלם",
                    "info": "מייל עם פרטי ההזמנה נשלח אליך לכתובת",
                },
                "waitingToApprove": {
                    "title": "ההזמנתך הועברה לאישור",
                    "info1": "פרטי ההזמנה נשמרו במערכת והועברו לאישור.",
                    "info2": 'תשלום התבצע רק לאחר אישור ההזמנה.',
                    "info3": 'מייל עם אישור ההזמנה ותשלום ישלח לאחר אישור ההזמנה.',
                },
                "paymentFail": {
                    "title": "התשלום נכשל",
                    "info1": "התשלום נכשל :(",
                    "infoFail": "לאחר מספר נסיונות, החיוב נכשל - אנה נסה שנית",
                    "infoWhatsapp": "במידה והתרחשה שגיאה, ואינך מצליח לשלם - יש ליצור קשר בוואטסאפ במספד: ",
                },
                "orderNum": "מספר ההזמנה",
                "thanksForChoose": "תודה שבחרת ב",
                "free": {
                    "title": "הרישום בוצע בהצלחה",
                    "info": "נשלח אליך מייל עם סיכום ההזמנה",
                } ,
                "pay_later": {
                    "title": "הרישום בוצע בהצלחה",
                    "info": "נשלח אליך מייל עם אישור ההזמנה",
                }
            },
            "paymentForm": {
                "card": "כרטיס אשראי",
                "creditCardInterest": "ריבית כרטיס אשראי",
                "interest": "ריבית",
                "noInterest": "ללא ריבית",
                "monthlyPayments": "חיוב חודשי",
                "monthsCount": "מספר חודשים",
                "priceCanNotBeOverBalance":"מחיר לתשלום לא יכול להיות מעל גובה היתרה",
                "total": "סה״כ קישורים לתשלום",
                "balance": "יתרה לתשלום",
                "updatedBalance":"יתרה עדכנית",
                "copyLink":"העתק קישור",
                "linkFor": "קישור עבור",
                "back": "חזרה",
                "createLink": "צור קישור",
                "setSpecificPrice":"יצירת לינק לתשלום",
                "setPriceAndSendPaymentLinkToClient":"הזן סכום לתשלום וצור לינק לתשלום ללקוח",
                "clientName":"שם הלקוח",
                "paymentPageFor":"דף תשלום עבור ",
                "forPayment":"לתשלום",
                "price":"מְחִיר",
                "copyPaymentLink":"העתק קישור לתשלום",
                "pleaseFillInBothFields":"נא למלא את שני השדות.",
                "paymentLinkCopiedToClipboard":"קישור התשלום הועתק ללוח!",
                "createLinkForPrice":"צור לינק לתשלום",
                "creditNotSaveInBd": " פרטי האשראי אינם נשמרים האתר - הינך משלים תשלום בדרך מאובטחת",
                "title": "הזן אמצעי תשלום",
                "splitBtn": "לחץ לפיצול כרטיסי אשראי",
                "splitTitle": "פיצול כרטיסי אשראי",
                "splitDesc": "בחר את הכמות כרטיסי אשראי לפיצול ולחץ אישור",
                "noSplit": "ללא פיצול",
                "noPayments": "ללא תשלומים",
                "payments": "תשלומים",
                "paymentsNum": "מספר תשלומים",
                "withDebit": "עם קרדיט",
                "splitBy": "כרטיסי אשראי",
                "toPay": "לתשלום",
                "splitApprove": "אישור",
                "currencyRate": " חיוב מתבצע בשקלים - לפי שער תיירות",
                "splitCurrentCardNum": "פיצול אשראי",
                "errorMessageToRetry": "נסיון מס׳ {retryNum} - תשלום נכשל מול מחברת האשראי, יש להזין שוב את פרטי כרטיס אשראי או כרטיס אחר. אתר מקבל כרטיס VISA ו MASTERCARD בלבד.",
                "splitCurrentCardNumFrom": "מתוך",
                "installments": "תשלומים",
                "installmentsLabel": "מספר תשלומים",
                "installmentFee": "עמלת תשלומים",
                "totalToPay": "סה״כ לתשלום",
                "perMonth": "לחודש",
                "installmentsDisclosure": "הסכום כולל עמלת תשלומים.",
            },
            "hotelTypes": {
                "Hotel": "מלון",
                "Apartment": "דירות",
                "Apart-hotel": "מלון דירות",
                "Guesthouse": "בית הארחה",
                "Resort": "ריזורט",
                "Boutique_and_Design": "מלון בוטיק",
            },
            "hotelDetails":{
                "updateDates":"עדכון תאריכים",
                "roomTypesToChooseFrom":"סוגי חדרים לבחירתך",

                "metapolicy": "מדיניות המלון",
                "metaExtraInfo": "פרטים נוספים",
                "not_included": "לא כלול",
                "included": "כלול",
                "price": "בעלות של",
                "address": "כתובת",
                "other": "כתובת",
                "Location": "מיקום מלון",
                "At the boutique hotel ": "על המלון",
                "Room amenities": "שירות חדרים",

                "parking": "חניה",
                "pets": "חיות מחמד",
                "shuttle": "הסעה לשדה (לכיוון)",
                "internet": "שירותי אינטרנט",
                "extra_bed": "מיטה נוספת",
                "add_fee": "תוספת תשלום",
                "children_meal": "ארוחת ילדים",
                "check_in_check_out": "צ׳ק אין וצ׳ק אווט",

            },
            "sideFilters": {
                "sortBy": "מיון לפי",
                "price_asc": "מחיר נמוך ביותר",
                "price_desc": "מחיר גבוה ביותר",
                "hotel_stars_asc": "כוכבי מלון נמוכים ביותר",
                "hotel_stars_desc": "כוכבי מלון גבוהים ביותר",
                "distance": "מרחק",
                "distance_asc": "מרחק נמוך ביותר",
                "distance_desc": "מרחק גבוה ביותר",
                "recommended": "מומלץ ביותר",
                "price": "מחיר",
                "clearSideFilters":"ניקוי מסננים",
                "ts_type": "סוגי טיסות",
                "auto_approve": "אישור מידי",
                "include_transfer": "כולל העברות",
                "include_baggage": "כולל מזוודה",
                "include_trolly": "כולל טרולי",
                "auto_approve_checked": "הצגת תוצאות אישור מידי",
                "from_date_hours": "שעת טיסה הלוך",
                "return_date_hours": "שעת טיסה חזור",
                "isSpecial": "האם מיוחד?",
                "is_special": "האם מיוחד?",
                "date_range": "טווח תאריכים",
                "from_date_landing_hours": "שעת טיסה הלוך",
                "flight_stop_time": "שעת עצירה",
                "return_date_landing_hours": "שעת טיסה חזור",
                "airline": "חברת תעופה",
                "2": "טיסות שכר",
                "3": "טיסות סדירות",
                "nonStop": "טיסה ישירה",
                "stop": "עצירה אחת",
                "stops_plural": "עצירות",
                "hotel_type": "סוגי אירוח",
                "stops": "מס׳ עצירות",
                "freeCancellation": "ביטול חינם?",
                "freeCancellationLabels": {
                    "1": "ביטול חינם בלבד",
                    "0": "ללא ביטול חינם",
                },

                "feature": "מאפיינים",

                "event_type": "סוגי אירועים",
                "avenue": "שדרה",
                "event_date": "תאריך אירוע",
            },
            "package_feature": {
                "SPECIAL PACKAGE": "חבילות מיוחדות",
                "ALL PACKAGES": "כל החבילות",
                "KOSHER": "מותאם כשר",
                // "TOUR": "סיור",
                "TOUR": "טיולים מאורגנים",
                "SKI": "סקי",
                "EVENT": "אירוע",
                "SPORT": "ספורט",
                "SPA": "ספא",
                "YOUNG VACATION": "חופשה לצעירים",
                "FLT+HTL+CAR": "טיסה+מלון+רכב"
            },
            "hotelAmenities": {
                // "dummy": "dummy"
            },
            "general":{
                "km": "קילומטר",
                "kmFromVenue": "קילומטרים מהמקום",
                "kmFromCityCenter": "קילומטרים מהמרכז העירוני",
                openBO: "חזור לממשק הניהול",
                logOut: "התנתקות",
                "toOrder": "להזמנה",
                "amount": "סכום",
                parentOriginal: "מודול אב",
                parentEdited: "מודול אב - ערוך",
                "fetchingMoreResults": "טוען תוצאות נוספות...",
                "error": "שגיאה",
                "somethingWentWrong": "משהו השתבש. נסו שוב.",
                "noResultsFound": "לא נמצאו אירועים",
                "tryAdjustingFilters": "נסו לשנות את המסננים או את קריטריוני החיפוש",
                "refresh": "רענן",
                "list": "רשימה",
                "matched": "מתאים",
                "rates": "מחירים",
                "calculatedRates": "מחירים מחושבים",
                "totalPrice": "מחיר כולל",
                "selected": "בחרת",
                "to": "ל",
                "roomOnly": 'למלון בלבד',
                "close": "סגור",
                "remark": "הערה",
                "addService": "הוסף שירות",
                "orgInfo": "מסלול",
                "tourInfo": "פרטי הטיול",
                packagesMainTitle: "חבילות נופש",
                vacationAtHeader: "חופשה ב",
                daysOfStay: "תאריכים",
                additionalFlights: "טיסות נוספות",
                flightsPromoTitle: "טיסות האחרון",
                lowPrice:"מחיר נמוך",
                flightUpTo: "טיסה מ",
                "additionalPackages": "חבילות נוספות",
                "packagePlan": "חבילות נופש מ",
                "immediateApproval": "אישור מיידי",
                "attraction":"אטרקציה",
                "includeReturnSuitcase":"כבודה כולל טיסה חזור",
                "base": "בסיס",
                "total": "סה״כ",
                "as_of_today": "נכון להיום",
                "priceInIls": "({price} ₪)",
                "link_to_the_offer": "לינק להצעה ",
                "the_quote_has_been_copied_successfully": "הצעת המחיר הועתקה בהצלחה",
                "submit": "חפש",
                "sort": "סנן",
                "recommended": "מומלץ ביותר",
                "maxAmountOf": "כמות מקסימלית של",
                "minAmountOf": "כמות מינימלית של",
                "ticketType": "סוג כרטיס",
                "timeSlot": "בחר זמן",
                "language": "שפה",
                "cancellation_policy": "מדיניות ביטולים",
                "additionalInfo": "מידע נוסף",
                "hour": "שעה",
                "minute": "דקה",
                "before": "לפני",
                "date": "תאריך",
                "duration": "משך זמן",
                "quantity": "כמות",
                "tickets": "כרטיסים",
                "deliveryMethod": "שיטת משלוח",
                "for":"עבור",
                "free":"חינם",
                "freeOfCharge": "ללא תשלום",
                'option': 'אופציה',
                'removeSelection': "הסר בחירה",
                'grandTotalPrice': 'מחיר כולל',
                'startingPrice': "מחיר התחלתי",
                "usd": "USD",
                "euro": "EURO",
                "availableSeats":"מקומות פנויים",
                "showGrossPrice":"הצג מחיר ברוטו",
                "showNetPrice":"הצג מחיר נטו",
                "noRating": "ללא דירוג",
                "address": "כתובת",
                "type": "סוג",
                "boardBasis":"בסיס אירוח",
                "supplier":"ספק",
                "airLine":"חברת תעופה",
                "price":"מחיר",
                "totalRoomPrice": "סה״כ מחיר לחדר",
                "priceForXRooms": "מחיר ל X חדרים",
                "hotel":"מלון",
                "hotel_stars":"כוכבי מלון",
                "minPrice":"החל מ",
                "BB":"ארוחת בוקר כלולה",
                "HB":"חצי פנסיון",
                "cancel":"ביטול",
                "replaceShoppingCart":"עגלת קניות לא נשמרת האם ברצונך להחליף אותה",
                "replace":"החלף",
                "searchForUser":"חפש לקוח לפי שם או טלפון",
                "fieldRequired":"שדה נדרש",
                "bundleFlight":"טיסה הלוך ושוב",
                "oneWayBundleFlight":"טיסה לכיוון אחד",
                "trollyIsIncluded":"טרולי כלול",
                "trollyIsNotIncluded":"ללא טרולי",
                "suitcaseIsIncluded":"מזוודה כלולה",
                "suitcaseIsNotIncluded":"ללא מזוודה",
                "additionalSuitcases":"כולל X מזוודות",
                "additionalTrolly":"כולל X טרולי",
                "returnFlight":"טיסה חזור",
                "outboundFlight":"טיסה הלוך",
                "agentMode":"מצב סוכן",
                "userMode":"מצב משתמש",
                "suitcase":"מזוודה",
                'trolly':"טרולי",
                "packageSearchResult":"החבילות שמצאנו עבורך",
                "day":"יום",
                "selectDate":"בחרו תאריכים",
                "search":"חיפוש",
                "adults":"מבוגרים",
                "adult":"מבוגר",
                "child":"ילד",
                "children":"ילדים",
                "infant":"תינוק",
                "infants":"תינוקות",
                "noResults":"אין תוצאות",
                "nights":"לילות",
                "includesActivities":"{NUMBER} אטרקציות מתנה!",
                "includesActivity":"כולל אטרקציה מתנה!",
                "all_include": "הכל כלול",
                "breakfast":"ארוחת בוקר",
                "half_board":"חצי פנסיון",
                "half_board_kosher":"חצי פנסיון כשר",
                "full_board" : "פנסיון מלא",
                "sleep_only" : "לינה בלבד",
                "breakfast_kidush" : "א.בוקר וא.ערב שישי",
                "addToCard": "הוסיפו להזמנה",
                "chooseRoom": "בחרו סוג חדר",
                "boardType":"בסיס לינה",
                "filters":"מסננים",
                "rating":"דירוג מלון",
                "event": "אירוע",
                "attraction_stars": "דירוג אטרקציה",
                "name": "שם",
                "taxonomies": "טקסונומיות",
                "toDate" : "עד",
                "transfers" : "העברות",
                "from" : "החל מ-",
                "perPerson" : "לאדם",
                "perPax": "ליחידה",
                "include" : "כולל",
                "noIncludeText" : "חבילות נופש",
                "flights" : "טיסות",
                "flight" : "טיסה",
                "vacationAt": "חופשה ב{DEST}",
                "showAll":"הצג הכול",
                "showLess":"הצג פחות",
                "h": " ש׳",
                "min": " ד׳",
                "acceptCookiesTitle":"אתר זה משתמש בקובצי Cookie. על-ידי שימוש באתר ובשירות שלנו אתה מסכים עם מדיניות השימוש שלנו בקובצי Cookie, כמתואר בתקנון האתר.",
                "acceptCookiesBtn":"קבל",

                "loading": "טוען",
                "showingMoreResults": "מציג תוצאות נוספות",
                "noMoreResults": "אין עוד תוצאות",
                "NoResultsMatchedTheFilterValues": "לא נמצאו תוצאות התואמות לערכי הסינון",
                "selectDestination": "בחר יעד או מלון לחיפוש",
                "eventTicketsAdded": "כרטיסים לאירוע נוספו",
                "addEventTickets": "הוסף כרטיסים לאירוע",
                "add": "הוסף",
            },
            "subsidizedForm":{
                "title":"הוספת סבסוד",
                "employee_id":"מספר עובד",
                "person_id":"ת.ז (9 ספרות)",
                "validate":"בדוק קוד עובד",
                "alreadyApplied":"הסבסוד כבר חל",
                "addOneMore":"הוסף סבסוד נוסף",
                "addOneMoreId":"הוסף עובד נוסף",
                "fieldRequired":"שדה חובה",
                "priceReducedBy":"מחיר מופחת ב",
                "forEmployee":"עבור עובד",
                "employeeIs":"זוהה בהצלחה ",
                "error4401":'נכשל בזיהוי, נסה שנית',
                "error4402":'קוד זוהה, אך כבר בשימוש',
                "guestIdentifiedId": 'מזוהה לפי ת.ז',
                "guestNotIdentified": 'יש להזדהות לפני רישום',
                "clickToIdentify":"לחץ להזדהות"
            },
            "uploadImage":{
                "uploadPassportImage":"העלאת צילום דרכון",
                "somethingWentWrong":"Something went wrong"
            },
            "flightButton":{
                "no_availability_for_this_flight_price": "מצטערים, אבל אין עוד זמינות לתמחור הטיסה הזה",
                "flightTotalPrice":"מחיר טיסה לכיוון",
                "total":"",
                "continueToOrder":"מעבר להזמנה",
                "addToCart":"הוסף לסל",
                "lastPlace":"מקומות אחרונים",
                "pricePerPassenger":"מחיר לנוסע",
                "cardConditions": "תנאי כרטיס",
            },
            "agentCommission":{
                'supplier':"ספק",
                'commission':"עמלה",
                "netPrice":"מחיר נטו",
                "recommendedFee":"עמלה",
                "transactionDetailsForAgent":"פרטי עסקה לסוכן",
                "supplierNotes":"הערות ספק",
                "cancellationConditions":"ותנאי ביטול",
                "addToCartToChangeFree":"הוסף לסל לשינוי עמלה",
                "pricesShownAreNetPrices":"המחירים המוצגים הינם מחירי נטו",
                "pricesShownAreGrossPrices":"המחירים המוצגים הם מחירים ברוטו",
                "packageRemarks": "הערות לחבילה",
            },
            "support": {
                "contactSupport": "צור קשר עם התמיכה",
                "submitTicket": "פתח פנייה",
                "myTickets": "הפניות שלי",
                "viewMyTickets": "צפה בפניות שלי",
                "selectCategory": "בחר קטגוריה",
                "selectReason": "בחר סיבה",
                "linkOrder": "קשר להזמנה (אופציונלי)",
                "describeIssue": "תאר את הבעיה",
                "review": "סקירה ושליחה",
                "categoryFlights": "טיסות",
                "categoryHotels": "מלונות",
                "categoryPackages": "חבילות",
                "categoryBilling": "חיוב ותשלומים",
                "categoryTechnical": "תמיכה טכנית",
                "categoryOther": "אחר",
                "reasonBookingIssue": "בעיית הזמנה",
                "reasonFlightCancellation": "ביטול טיסה",
                "reasonFlightChange": "שינוי טיסה",
                "reasonSeatSelection": "בחירת מושב",
                "reasonBaggageIssue": "בעיית מטען",
                "reasonRefundRequest": "בקשת החזר",
                "reasonOther": "אחר",
                "reasonReservationChange": "שינוי הזמנה",
                "reasonRoomUpgrade": "שדרוג חדר",
                "reasonCancellationRequest": "בקשת ביטול",
                "reasonAmenitiesQuestion": "שאלה על שירותים",
                "reasonAddServices": "הוספת שירותים",
                "reasonPackageModification": "שינוי חבילה",
                "reasonItineraryQuestion": "שאלה על מסלול",
                "reasonPaymentFailed": "תשלום נכשל",
                "reasonRefundStatus": "סטטוס החזר",
                "reasonInvoiceRequest": "בקשת חשבונית",
                "reasonPricingQuestion": "שאלת תמחור",
                "reasonPaymentMethod": "אמצעי תשלום",
                "reasonLoginProblem": "בעיית התחברות",
                "reasonWebsiteError": "שגיאת אתר",
                "reasonMobileAppIssue": "בעיה באפליקציה",
                "reasonPaymentGateway": "שער תשלום",
                "reasonGeneralInquiry": "פנייה כללית",
                "reasonFeedback": "משוב",
                "reasonComplaint": "תלונה",
                "reasonSuggestion": "הצעה",
                "fullName": "שם מלא",
                "fullNamePlaceholder": "הזן את שמך המלא",
                "email": "אימייל",
                "emailPlaceholder": "your.email@example.com",
                "phone": "טלפון (אופציונלי)",
                "phonePlaceholder": "+ 972 -",
                "subject": "נושא",
                "subjectPlaceholder": "תיאור קצר של הבעיה",
                "priority": "עדיפות",
                "priorityLow": "נמוכה",
                "priorityMedium": "בינונית",
                "priorityHigh": "גבוהה",
                "priorityUrgent": "דחופה",
                "description": "תיאור מפורט",
                "descriptionPlaceholder": "אנא ספק פרטים רבים ככל האפשר על הבעיה...",
                "attachments": "קבצים מצורפים",
                "attachmentsHint": "ניתן לצרף עד 5 קבצים (מקסימום 2MB כל אחד)",
                "selectOrder": "בחר הזמנה קשורה",
                "searchOrders": "חפש הזמנות לפי יעד, תאריכים או מספר הזמנה...",
                "noOrders": "לא נמצאו הזמנות",
                "manualOrderId": "הזן את מספר ההזמנה שלך:",
                "orderIdPlaceholder": "לדוגמה: 12345",
                "signedInAs": "מחובר כ",
                "guestUser": "משתמש אורח",
                "requiredForGuests": "נדרש לשליחה",
                "consentLabel": "אני מסכים לתנאים וההגבלות",
                "consentText": "בשליחת פנייה זו, אני מאשר שהמידע שסופק מדויק ואני מסכים לעיבוד הנתונים האישיים שלי על ידי Sky 360 לצורך פתרון הפנייה.",
                "next": "הבא",
                "back": "חזור",
                "submit": "שלח פנייה",
                "cancel": "ביטול",
                "addFile": "הוסף קובץ",
                "removeFile": "הסר",
                "selectFile": "בחר קבצים",
                "required": "שדה חובה",
                "invalidEmail": "אנא הזן כתובת אימייל תקינה",
                "selectCategoryRequired": "אנא בחר קטגוריה",
                "selectReasonRequired": "אנא בחר סיבה",
                "descriptionTooShort": "אנא ספק פרטים נוספים (מינימום 20 תווים)",
                "fileTooLarge": "גודל הקובץ עולה על 2MB",
                "tooManyFiles": "מקסימום 5 קבצים מותרים",
                "invalidFileType": "סוג קובץ לא נתמך",
                "consentRequired": "עליך להסכים לתנאים כדי לשלוח",
                "successTitle": "הפנייה נשלחה בהצלחה!",
                "successMessage": "פנייתך נוצרה. נבדוק אותה בקרוב ונחזור אליך.",
                "ticketNumber": "מספר פנייה",
                "nextSteps": "מה קורה הלאה?",
                "nextStepsText": "צוות התמיכה שלנו יבדוק את הפנייה ויגיב תוך 24-48 שעות. תקבל עדכונים באימייל ל",
                "emailConfirmation": "אימייל אישור נשלח לתיבת הדואר שלך.",
                "ticketId": "פנייה",
                "status": "סטטוס",
                "category": "קטגוריה",
                "lastUpdated": "עדכון אחרון",
                "created": "נוצר",
                "open": "פתוח",
                "pending": "ממתין",
                "resolved": "נפתר",
                "closed": "סגור",
                "noTickets": "לא נמצאו פניות תמיכה",
                "noTicketsMessage": "עדיין לא שלחת פניות תמיכה.",
                "orderNumber": "הזמנה",
                "orderDestination": "יעד",
                "orderDates": "תאריכי נסיעה",
                "orderAmount": "סכום",
                "orderStatus": "סטטוס",
                "priorityP1": "קריטי",
                "priorityP2": "גבוה",
                "priorityP3": "בינוני",
                "priorityP4": "נמוך",
                "errorSubmitting": "שליחת הפנייה נכשלה. אנא נסה שוב.",
                "errorLoadingOrders": "טעינת הזמנות נכשלה.",
                "networkError": "שגיאת רשת. אנא בדוק את החיבור שלך.",
                "needHelp": "צריך עזרה?",
            },
            "blog": {
                "home": "בית",
                "blog": "בלוג",
                "categories": "קטגוריות",
                "articles": "מאמרים",
                "articlesIn": "מאמרים ב",
                "latestTravelStories": "סיפורי הטיול האחרונים",
                "discoverInspiring": "גלו יעדים מעוררי השראה וטיפים מומחים לטיולים",
                "viewAllArticles": "צפו בכל המאמרים",
                "readMore": "קרא עוד",
                "minRead": "דקות קריאה",
                "addBookmark": "הוסף לסימניות",
                "removeBookmark": "הסר מהסימניות",
                "shareThisArticle": "שתפו את המאמר",
                "shareThisCategory": "שתפו קטגוריה זו",
                "shareWithFriendsAndFamily": "שתפו את המאמרים האהובים עליכם עם חברים ומשפחה",
                "share": "שתף",
                "shareOnFacebook": "שתף בפייסבוק",
                "shareOnTwitter": "שתף בטוויטר",
                "shareOnLinkedIn": "שתף בלינקדאין",
                "shareOnPinterest": "שתף בפינטרסט",
                "shareOnInstagram": "שתף באינסטגרם",
                "copyLink": "העתק קישור",
                "linkCopied": "הקישור הועתק!",
                "copied": "הועתק!",
                "copyFailed": "העתקת הקישור נכשלה",
                "followUs": "עקבו אחרינו",
                "instagram": "אינסטגרם",
                "facebook": "פייסבוק",
                "twitter": "טוויטר",
                "relatedArticles": "מאמרים קשורים",
                "noPostsFound": "לא נמצאו פוסטים בקטגוריה זו",
                "postNotFound": "הפוסט לא נמצא",
                "showing": "מציג",
                "sortBy": "מיון לפי:",
                "newestFirst": "החדש ביותר",
                "alphabetical": "א-ת",
                "gridView": "תצוגת רשת",
                "listView": "תצוגת רשימה",
                "exploreMoreCategories": "גלו עוד קטגוריות",
                "travelInspiration": "השראה לטיולים",
                "getWeeklyGuides": "גלו אתרי סוד וטיפים בלעדיים לטיולים שנאספו למגיעים כמוכם",
                "bookYourFlight": "הזמינו את הטיסה שלכם",
                "facebookShare": "Facebook",
                "twitterShare": "Twitter",
                "instagramShare": "Instagram",
                "linkedinShare": "LinkedIn",
                "whatsappShare": "WhatsApp",
                "pinterestShare": "Pinterest",
                "shareArticle": "שתפו את המאמר",
                "shareCategory": "שתפו קטגוריה",
            },
            "onboarding": {
                "openOnboarding": "מדריך",
                "welcomeTitle": "ברוכים הבאים לסקיי360",
                "subtitle": "נצלו את הפלטפורמה שלנו במיטבה עם הסיור המהיר הזה. השלימו כל שלב כדי לגלות את כל מה שאנו מציעים.",
                "progressTitle": "ההתקדמות שלכם",
                "progressLabel": "הושלם",
                "continueOnboarding": "המשך",
                "yourPath": "שלבי ה-Onboarding שלכם",
                "pathSubtitle": "עקבו אחר השלבים הללו כדי לגלות את כל המוצרים שלנו.",
                "markAsDone": "סמן כהושלם",
                "upNext": "הבא",
                "continue": "המשך",
                "outcomesTitle": "מה תלמדו",
                "outcome1": "חיפוש והזמנת טיולים",
                "outcome1Desc": "מצאו חבילות, טיסות, מלונות ועוד.",
                "outcome2": "גלו אירועים ואטרקציות",
                "outcome2Desc": "גלו חוויות מקומיות ביעד שלכם.",
                "stepCompleted": "הושלם",
                "stepCompletedBanner": "השלב הושלם! אתם מתקדמים יפה.",
                "stepCompletionTitle": "שלב {num} הושלם!",
                "stepCompletionKicker": "עבודה מצוינת — המשיכו!",
                "tasksCompleted": "משימות: {done}/{total} הושלמו",
                "typeTask": "בצע",
                "stepLabel": "שלב",
                "nextStepHint": "הבא: שלב {num} — {title}",
                "continueUpNext": "התחל",
                "tourFinishBtn": "סיים",
                "tourNextBtn": "הבא",
                "tourPrevBtn": "חזור",
                "tourActionHint": "👆 לחצו על הכפתור למעלה כדי להמשיך",
                "typeLearn": "למד",
                "steps": {
                    "step1": {
                        "title": "חיפוש חבילות נופש",
                        "description": "למדו כיצד למצוא ולהזמין חבילות נופש הכוללות טיסות ומלונות."
                    },
                    "step2": {
                        "title": "חיפוש טיסות",
                        "description": "מצאו טיסות בכיוון אחד או הלוך-חזור, הגדירו נוסעים ובחרו תאריכי נסיעה."
                    },
                    "step3": {
                        "title": "חיפוש מלונות",
                        "description": "עיינו במלונות ברחבי העולם לפי יעד, תאריכי צ'ק-אין ומספר אורחים."
                    },
                    "step4": {
                        "title": "גלו אטרקציות",
                        "description": "גלו פעילויות מקומיות ואטרקציות תיירותיות ביעד שלכם."
                    },
                    "step5": {
                        "title": "מצאו אירועים",
                        "description": "עיינו באירועים קרובים ובאופן אופציונלי שלבו אותם עם טיסות ומלון."
                    },
                    "step6": {
                        "title": "סקירת מנוע החיפוש",
                        "description": "אזור החיפוש הראשי מאפשר לכם לעבור בין כל סוגי המוצרים ממקום אחד."
                    },
                    "step7": {
                        "title": "חיפוש חבילות דינמיות",
                        "description": "למדו כיצד לבנות חבילת נסיעה מותאמת אישית על ידי בחירת יעד, מלון וטיסה ישירה."
                    },
                    "step8": {
                        "title": "יצירת הזמנת טיסה",
                        "description": "עברו על תהליך הזמנת הטיסה המלא — מחיפוש טיסות ועד לתשלום."
                    },
                    "step9": {
                        "title": "סקירת לוח הסוכן",
                        "description": "לוח הסוכן מופיע בחלק העליון של ה-B2C ומאפשר לניהול לקוחות, הגדרות מחיר, צפייה ביתרת יהלומים ועוד."
                    },
                    "step10": {
                        "title": "יצירת הזמנת חבילה",
                        "description": "עברו על תהליך הזמנת החבילה המלא — מחיפוש חבילות ועד לתשלום."
                    },
                    "step11": {
                        "title": "סיור בדף ניהול ההזמנה",
                        "description": "עברו על דף ניהול ההזמנה — עיינו בפרטי ההזמנה, עדכנו פרטי אורחים ועברו לסעיף התשלום."
                    }
                },
                "tour": {
                    "seModHoverTitle": "גלו את פעולות המודול",
                    "seModHoverDesc": "רחפו מעל כל מודול בעמוד שלמטה — יופיע סרגל פעולות קטן עבור אותו מודול. רחפו מעל אחד עכשיו כדי לעבור על מה שכל פעולה עושה.",
                    "seModAddTopTitle": "הוספת מודול מעל",
                    "seModAddTopDesc": "מוסיף מודול חדש לגמרי ישירות מעל המודול הזה. לחצו עליו כדי לבחור סוג מודול ולמקם אותו.",
                    "seModReorderTitle": "שינוי סדר המודול",
                    "seModReorderDesc": "השתמשו בחיצים למעלה ולמטה כדי להזיז את המודול קדימה או אחורה בעמוד. התצוגה מתעדכנת מיידית.",
                    "seModEditTitle": "עריכת המודול",
                    "seModEditDesc": "פותח את המודול הזה בפאנל ההגדרות מצד שמאל, שם תוכלו לשנות את התוכן, הפריסה והעיצוב שלו.",
                    "seModDeleteTitle": "הסרת המודול",
                    "seModDeleteDesc": "מוחק את המודול הזה מהעמוד. תמיד תוכלו להוסיף אותו שוב מאוחר יותר דרך אפשרויות הוספת המודול.",
                    "seModAddBottomTitle": "הוספת מודול מתחת",
                    "seModAddBottomDesc": "מוסיף מודול חדש לגמרי ישירות מתחת למודול הזה — בדיוק כמו הכפתור העליון, רק עבור המיקום שמתחת.",
                    "packagesDpSwitchTitle": "חבילות דינמיות — טיסה + מלון",
                    "packagesDpSwitchDesc": "עברו למצב חבילה דינמית — בחרו מלון והמערכת תשלב אותו עם הטיסה הזולה ביותר הזמינה למסלול, ותיצור מחיר חבילה מלא ותחרותי על המקום.",
                    "packagesFeaturesTitle": "קטגוריות חבילות",
                    "packagesFeaturesDesc": "בחרו את סוג חבילת הנופש שאתם מחפשים — סיורים מאורגנים, נסיעות ספורט, טיולים כשרים ועוד.",
                    "pkgSpecialTitle": "חבילות מיוחדות — עמלה קבועה 10%",
                    "pkgSpecialDesc": "זו קטגוריית החבילות המיוחדות — חבילות טיול קבוצתי המופעלות על ידי הפלטפורמה. לכל חבילה מיוחדת יש עמלת סוכן קבועה של 10% כלולה מראש — מושלם למכירה מהירה וביטחון מלא, ללא צורך במשא ומתן על מחירים.",
                    "pkgOtherCatsTitle": "קטגוריות נוספות",
                    "pkgOtherCatsDesc": "אלו הן קטגוריות החבילות הנוספות — סיורים מאורגנים, נסיעות כשרות, טיולי סקי, חופשות ספא, אירועי ספורט ועוד. כל קטגוריה מסננת אוטומטית את החבילות הזמינות ואת היעדים בהתאם לסוג הנסיעה.",
                    "pkgSelectCatTitle": "נסו — בחרו קטגוריה",
                    "pkgSelectCatDesc": "לחצו על אחת מקטגוריות החבילות כדי לסנן לפי סוג הנסיעה. שימו לב כיצד רשימת היעדים הזמינים מתעדכנת אוטומטית בהתאם לקטגוריה שנבחרה.",
                    "pkgFilteredDestsTitle": "יעדים מסוננים",
                    "pkgFilteredDestsDesc": "לאחר בחירת קטגוריה, רשימת היעדים מסוננת אוטומטית להצגת המיקומים שבהם קיימות חבילות מאותו סוג. בחרו יעד כדי להמשיך.",
                    "pkgDeselectCatTitle": "לחצו שוב לביטול הבחירה",
                    "pkgDeselectCatDesc": "לחיצה שנייה על הקטגוריה הפעילה תבטל את הבחירה ותחזיר את רשימת היעדים לכל החבילות הזמינות. נסו עכשיו כדי להמשיך.",
                    "pkgDepartureTitle": "עיר היציאה",
                    "pkgDepartureDesc": "בחרו את שדה התעופה או העיר ממנה תטוסו לחבילת הנופש שלכם.",
                    "packagesDestTitle": "בחר יעד",
                    "packagesDestDesc": "בחרו יעד אחד או יותר לחבילת הנופש שלכם.",
                    "packagesGuestsTitle": "נוסעים",
                    "packagesGuestsDesc": "בחרו את מספר הנוסעים — מבוגרים, ילדים ותינוקות — עבור חבילת הנופש שלכם.",
                    "packagesDatesTitle": "תאריכי נסיעה",
                    "packagesDatesDesc": "בחרו תאריכי יציאה וחזרה לחבילה.",
                    "packagesSearchTitle": "חפשו חבילות",
                    "packagesSearchDesc": "לחצו כאן כדי למצוא חבילות זמינות המתאימות לקריטריונים שלכם.",
                    "flightTripTypeTitle": "סוג הנסיעה",
                    "flightTripTypeDesc": "החליפו בין טיסה בכיוון אחד להלוך-חזור. כיוון אחד מציג תאריך יחיד; הלוך-חזור מציג תאריכי יציאה וחזרה.",
                    "flightDirectTitle": "טיסות ישירות בלבד",
                    "flightDirectDesc": "הפעילו מתג זה לסינון תוצאות לטיסות ישירות בלבד — ללא עצירות ביניים.",
                    "flightDepartureTitle": "עיר היציאה",
                    "flightDepartureDesc": "בחרו את שדה התעופה או העיר ממנה תטוסו.",
                    "flightArrivalTitle": "יעד",
                    "flightArrivalDesc": "בחרו את שדה התעופה או העיר אליה ברצונכם לטוס.",
                    "flightPaxTitle": "נוסעים",
                    "flightPaxDesc": "פתחו את בורר הנוסעים להגדרת מספר מבוגרים, ילדים ותינוקות.",
                    "flightDatesTitle": "תאריכי טיסה",
                    "flightDatesDesc": "בחרו את תאריך היציאה (ותאריך החזרה לטיסות הלוך-חזור). טיסה בכיוון אחד דורשת רק תאריך יציאה.",
                    "flightSearchTitle": "חפשו טיסות",
                    "flightSearchDesc": "לחצו לחיפוש טיסות זמינות עם האפשרויות שבחרתם.",
                    "hotelDestTitle": "יעד המלון",
                    "hotelDestDesc": "חפשו את העיר או האזור שבו תרצו להתאכסן.",
                    "hotelGuestsTitle": "חדרים ואורחים",
                    "hotelGuestsDesc": "הוסיפו כמה חדרים שתצטרכו והגדירו כל אחד בנפרד — קבעו מספר מבוגרים, ילדים ותינוקות לכל חדר. ניתן לשלב הגדרות שונות בהתאם להרכב הקבוצה — זוגות, משפחות, או כל שילוב אחר.",
                    "hotelDatesTitle": "צ'ק-אין וצ'ק-אאוט",
                    "hotelDatesDesc": "בחרו את תאריכי הצ'ק-אין והצ'ק-אאוט במלון.",
                    "hotelSearchTitle": "חפשו מלונות",
                    "hotelSearchDesc": "לחצו לעיון במלונות זמינים ליעד ותאריכים שלכם.",
                    "attrDestTitle": "עיר האטרקציה",
                    "attrDestDesc": "הקלידו או בחרו את העיר שבה ברצונכם למצוא אטרקציות ופעילויות.",
                    "attrDatesTitle": "תאריכי הפעילות",
                    "attrDatesDesc": "בחרו את טווח התאריכים לפעילויות שברצונכם לחקור.",
                    "attrTypeTitle": "סוג האטרקציה",
                    "attrTypeDesc": "סננו אטרקציות לפי קטגוריה — מוזיאונים, פעילויות חוץ, סיורים מודרכים ועוד.",
                    "attrSearchTitle": "מצאו אטרקציות",
                    "attrSearchDesc": "לחצו לחיפוש אטרקציות זמינות בעיר שבחרתם.",
                    "eventsPackageTitle": "כלול חבילה מלאה",
                    "eventsPackageDesc": "הפעילו מתג זה כדי לשלב את האירוע עם טיסה ומלון — חבילת נסיעה מלאה בהזמנה אחת.",
                    "eventsEventTitle": "חפשו אירוע",
                    "eventsEventDesc": "הקלידו שם אירוע או עיינו באירועים זמינים. כשחבילה מלאה מופעלת, הזינו עיר יעד במקום.",
                    "eventsDatesTitle": "תאריכי האירוע",
                    "eventsDatesDesc": "בחרו את טווח התאריכים המכסה את האירוע שברצונכם להשתתף בו.",
                    "eventsSearchTitle": "מצאו אירועים",
                    "eventsSearchDesc": "לחצו לחיפוש אירועים המתאימים ליעד ולתאריכים שלכם.",
                    "mainTabsTitle": "בחרו סוג חיפוש",
                    "mainTabsDesc": "השתמשו בלשוניות אלה כדי לעבור בין חבילות נופש, טיסות, מלונות, אטרקציות ואירועים. כל לשונית מציגה טופס חיפוש מותאם.",
                    "mainFormTitle": "טופס החיפוש",
                    "mainFormDesc": "מלאו את פרטי הנסיעה — יעד, תאריכים, נוסעים — ולחצו על חפש כדי למצוא תוצאות.",
                    "mainPkgTabTitle": "חבילות נופש",
                    "mainPkgTabDesc": "מצאו חבילות נופש כוללות המשלבות טיסות ומלונות. לחצו על לשונית זו כדי לראות את טופס חיפוש החבילות.",
                    "mainPkgFormTitle": "טופס חיפוש חבילות",
                    "mainPkgFormDesc": "הגדירו עיר יציאה, יעד, תאריכי נסיעה ותצורת חדרים לחבילות נופש. כל שדה מסייע למצוא את האפשרויות המתאימות ביותר ללקוחותיכם.",
                    "mainFltTabTitle": "טיסות",
                    "mainFltTabDesc": "חפשו טיסות בודדות — כיוון אחד או הלוך ושוב. לחצו על לשונית זו כדי לראות את טופס חיפוש הטיסות.",
                    "mainFltFormTitle": "טופס חיפוש טיסות",
                    "mainFltFormDesc": "בחרו סוג טיסה, ערי יציאה ויעד, תאריכי נסיעה ומספר נוסעים. הפעילו 'טיסות ישירות בלבד' כדי לסנן עצירות ביניים.",
                    "mainHtlTabTitle": "מלונות",
                    "mainHtlTabDesc": "חפשו מלונות בכל העולם ללא חבילה מלאה. לחצו על לשונית זו כדי לראות את טופס חיפוש המלונות.",
                    "mainHtlFormTitle": "טופס חיפוש מלונות",
                    "mainHtlFormDesc": "הזינו יעד, תאריכי צ׳ק-אין וצ׳ק-אאוט ותצורת חדרים. הוסיפו מספר חדרים והגדירו כל אחד בנפרד בהתאם לקבוצה שלכם.",
                    "mainAttrTabTitle": "אטרקציות",
                    "mainAttrTabDesc": "גלו פעילויות מקומיות, סיורים מודרכים ודברים לעשות בכל יעד. לחצו על לשונית זו כדי לראות את טופס חיפוש האטרקציות.",
                    "mainAttrFormTitle": "טופס חיפוש אטרקציות",
                    "mainAttrFormDesc": "בחרו עיר, טווח תאריכים וסוג אטרקציה כדי למצוא פעילויות זמינות ביעד. מושלם להוספת תוספות לכל הזמנה.",
                    "mainEvtTabTitle": "ספורט והופעות",
                    "mainEvtTabDesc": "הזמינו כרטיסים לקונצרטים, משחקי ספורט, פסטיבלים ואירועים נוספים — אפשרות לחבילה מלאה עם טיסה ומלון. לחצו על לשונית זו כדי לראות את טופס חיפוש האירועים.",
                    "mainEvtFormTitle": "טופס חיפוש אירועים",
                    "mainEvtFormDesc": "חפשו אירועים לפי שם או יעד והגדירו תאריכים. הפעילו 'חבילה מלאה' כדי לשלב את האירוע עם טיסה ומלון להזמנה מלאה אחת.",
                    "dynDpSwitchTitle": "טיסה + מלון — חבילה דינמית",
                    "dynDpSwitchDesc": "חבילות דינמיות משלבות מלון לבחירתכם עם הטיסה הזולה ביותר הזמינה למסלול — ויוצרות מחיר חבילה תחרותי ומלא על המקום. המערכת נועלת אוטומטית את מחיר הטיסה הטוב ביותר ומשלבת אותו עם תוצאות המלון שלכם.",
                    "dynDirectTitle": "טיסה ישירה",
                    "dynDirectDesc": "כאשר מופעל, התוצאות יוגבלו לטיסות ישירות בלבד. כבו כדי לכלול גם טיסות עם עצירות.",
                    "dynDepartureTitle": "עיר היציאה",
                    "dynDepartureDesc": "בחרו את שדה התעופה או העיר ממנה תטוסו לחבילה הדינמית שלכם.",
                    "dynDestTitle": "יעד או שם מלון",
                    "dynDestDesc": "חפשו לפי עיר יעד לגלות את כל המלונות הזמינים באזור — או הקלידו שם מלון ספציפי לעבור ישירות לאותו נכס. מעבר ישיר למלון מהיר יותר כשללקוח שלכם יש כבר העדפה, ועוזר לבנות את החבילה הטובה ביותר בשניות.",
                    "dynDatesTitle": "תאריכי לינה",
                    "dynDatesDesc": "בחרו תאריכי צ'ק-אין וצ'ק-אאוט למלון.",
                    "dynGuestsTitle": "חדרים ואורחים",
                    "dynGuestsDesc": "הוסיפו כמה חדרים שתצטרכו והגדירו כל אחד בנפרד — קבעו מספר מבוגרים, ילדים ותינוקות לכל חדר. שלבו הגדרות שונות בהתאם לקבוצת הלקוח — למשל משפחה עם ילדים בחדר אחד וזוג בחדר אחר.",
                    "dynSearchTitle": "חפשו חבילה דינמית",
                    "dynSearchDesc": "לחצו לחיפוש חבילות דינמיות זמינות ליעד, תאריכים ונוסעים שבחרתם.",
                    "fltSearchActionTitle": "חפשו טיסה",
                    "fltSearchActionDesc": "מלאו את פרטי הנסיעה ולחצו על חפש כדי לראות טיסות זמינות.",
                    "fltResOnewayDayTitle": "ניווט מהיר לפי תאריך",
                    "fltResOnewayDayDesc": "השתמשו בכרטיסיות הימים כדי לעבור במהירות לתאריך יציאה אחר ולראות מחירים מעודכנים.",
                    "fltResOnewayFiltersTitle": "סננו תוצאות",
                    "fltResOnewayFiltersDesc": "השתמשו במסננים הצדדיים לצמצום תוצאות לפי חברת תעופה, טווח מחירים, מספר עצירות וזמני טיסה.",
                    "fltResOnewayCardsTitle": "טיסות זמינות",
                    "fltResOnewayCardsDesc": "עיינו ברשימת הטיסות הזמינות. כל כרטיס מציג חברת תעופה, מספר טיסה, משך, עצירות ומחיר לנוסע.",
                    "fltResOnewayActionTitle": "בחרו טיסה",
                    "fltResOnewayActionDesc": "לחצו על \"בחר טיסה\" בכל כרטיס כדי להמשיך לדף פרטי ההזמנה.",
                    "fltResBundleTabTitle": "טיסות הלוך ושוב מול דינמי",
                    "fltResBundleTabDesc": "עברו בין \"בחרו את הטיסות בעצמכם\" - כולל מקטעים גמישים חד-כיוונים ונייוט בין תאריכים ל\"טיסה מוגדרות מראש\" - טיסות הלוך ושוב.",
                    "fltResBundleFiltersTitle": "סננו תוצאות",
                    "fltResBundleFiltersDesc": "השתמשו במסננים הצדדיים לצמצום תוצאות לפי חברת תעופה, טווח מחירים, מספר עצירות וזמני טיסה.",
                    "fltResBundleCardsTitle": "אפשרויות טיסה מחוברת",
                    "fltResBundleCardsDesc": "כל כרטיס מציג חבילת הלוך וחזור עם פרטי טיסת הלוך וחזור ומחיר כולל.",
                    "fltResBundleActionTitle": "מעבר להזמנה",
                    "fltResBundleActionDesc": "לחצו על \"מעבר להזמנה\" בטיסה המועדפת לצפייה בפרטים ולהוספה לעגלת הקניות.",
                    "fltResBundleResumeActionTitle": "מעבר להזמנה",
                    "fltResBundleResumeActionDesc": "בחרו טיסה מחוברת ולחצו 'מעבר להזמנה' כדי להמשיך.",
                    "fltResDynDayTitle": "ניווט תאריכים מהיר",
                    "fltResDynDayDesc": "השתמשו בכרטיסיות התאריכים לקפיצה מהירה לתאריך יציאה אחר ולראות כיצד המחירים משתנים.",
                    "fltResDynFiltersTitle": "סננו תוצאות",
                    "fltResDynFiltersDesc": "צמצמו תוצאות לפי חברת תעופה, עצירות, טווח מחירים ושעות יציאה ונחיתה.",
                    "fltResDynOutboundTitle": "טיסות יציאה",
                    "fltResDynOutboundDesc": "עיינו ברשימת טיסות ההלוך הזמינות. כל כרטיס מציג חברת תעופה, מסלול, שעות ומחיר לנוסע.",
                    "fltResDynOutboundActionTitle": "בחרו טיסת יציאה",
                    "fltResDynOutboundActionDesc": "לחצו על 'בחר טיסה' בכרטיס ההלוך המועדף עליכם כדי לנעול אותו.",
                    "fltResDynReturnTitle": "טיסות חזרה",
                    "fltResDynReturnDesc": "כעת בחרו את טיסת החזרה שלכם. עיינו בכל האפשרויות הזמינות לנסיעה הביתה.",
                    "fltResDynReturnActionTitle": "בחרו טיסת חזרה",
                    "fltResDynReturnActionDesc": "לחצו על 'בחר טיסה' כדי לנעול את הכיוון החוזר.",
                    "fltResDynFinalTitle": "הטיסות שנבחרו",
                    "fltResDynFinalDesc": "שתי הטיסות נבחרו. בדקו את המחיר המשולב לפני המשך.",
                    "fltResDynFinalActionTitle": "מעבר להזמנה",
                    "fltResDynFinalActionDesc": "לחצו על 'מעבר להזמנה' לצפייה בפרטי ההזמנה המלאים.",
                    "fltViewAgentCommTitle": "עמלת סוכן",
                    "fltViewAgentCommDesc": "בדקו את עמלת הסוכן המוצעת לטיסה זו לפני ההוספה לעגלה.",
                    "fltViewCardTitle": "פרטי הטיסה",
                    "fltViewCardDesc": "סקרו את מידע הטיסה המלא — חברת תעופה, מסלול, זמנים, עצירות ואפשרויות כבודה — לפני ההזמנה.",
                    "fltViewPriceTitle": "סיכום מחיר",
                    "fltViewPriceDesc": "המחיר הכולל מוצג לנוסע ובסך הכל. סוכנים יכולים גם להגדיר עמלה לפני ההוספה לעגלה.",
                    "fltViewTcTitle": "תנאים והגבלות",
                    "fltViewTcDesc": "סקרו את כללי התעריף ותנאי הביטול — כולל מגבלות חשובות — לפני ההוספה לעגלה.",
                    "fltViewActionTitle": "הוסיפו לעגלה",
                    "fltViewActionDesc": "לחצו על \"הוסף לעגלה\" כדי לשריין את הטיסה. העגלה תיפתח לסקירה לפני המעבר לתשלום.",
                    "fltCartProductsTitle": "העגלה שלכם",
                    "fltCartProductsDesc": "העגלה שלכם יכולה להכיל מוצרים מרובים מכל סוג — טיסות, מלונות, חבילות ועוד. תוכלו להוסיף כמה פריטים שתרצו בהזמנה אחת. בדקו את כל מה שנוסף כאן לפני שתמשיכו.",
                    "fltCartItemsTitle": "פריטי העגלה",
                    "fltCartItemsDesc": "כל מוצר בעגלה שלכם מפורט כאן — פרטי טיסה, סוג חדר, תאריכים וחלוקת נוסעים. ודאו שכל הפריטים נכונים לפני שמירה או המשך.",
                    "fltCartManageBaggageTitle": "ניהול כבודה",
                    "fltCartManageBaggageDesc": "לחצו על כפתור זה לניהול תוספות כבודה לכל נוסע — ניתן להוסיף מזוודות נוספות ולהתאים את אפשרויות הכבודה לטיסת הלוך ולטיסת החזור בנפרד.",
                    "fltCartDiamondsTitle": "יהלומים",
                    "fltCartDiamondsDesc": "ספירת היהלומים מציגה את תגמול הקאשבק שתצברו מהזמנה זו.",
                    "fltCartAgentTitle": "אפשרויות סוכן",
                    "fltCartAgentDesc": "כסוכן, יש לכם שליטה מלאה על העמלה שלכם בהזמנה זו. הגדירו אחוז מהסכום הכולל או סכום קבוע לנוסע — אתם קובעים כמה רווח תרוויחו בכל הזמנה.",
                    "fltCartAgentProfitBtnTitle": "שינוי רווח",
                    "fltCartAgentProfitBtnDesc": "לחצו על כפתור זה כדי לפתוח את הגדרות הרווח ולהתאים את חישוב העמלה.",
                    "fltCartAgentProfitInputsTitle": "הגדרות רווח",
                    "fltCartAgentProfitInputsDesc": "הזינו אחוז מהמחיר הכולל או סכום קבוע לנוסע. המערכת מחשבת לפי הסוג הפעיל.",
                    "fltCartAgentSendBtnTitle": "שליחת הצעה",
                    "fltCartAgentSendBtnDesc": "כדי לקבל קישור הצעה פעיל: ראשית שייכו לקוח להזמנה, לאחר מכן לחצו על שמור הצעה — פעולה זו יוצרת את הקישור. לאחר השמירה, לחצו על כפתור זה לפתיחת חלונית שלח הצעה שם תוכלו להעתיק את הקישור הפעיל, לשלוח אותו בוואטסאפ או לשתף בדוא\"ל. הקישור הפעיל מספק ללקוח תצוגה בזמן אמת של ההזמנה עם מחירים עדכניים תמיד.",
                    "fltCartAssignCustomerTitle": "שייכו לקוח",
                    "fltCartAssignCustomerDesc": "לחצו על כפתור 'שייך לקוח' כדי לפתוח את טופס פרטי הלקוח ולקשר אותו להזמנה הזו.",
                    "fltCartAssignModalTitle": "מלאו את פרטי הלקוח",
                    "fltCartAssignModalDesc": "מלאו את השדות הנדרשים — שם, טלפון, אימייל — ולחצו על שמור לקוח כדי לקשר אותו להזמנה. החלון ייסגר אוטומטית לאחר השמירה.",
                    "fltCartCustomerTitle": "לקוח מקושר",
                    "fltCartCustomerDesc": "הלקוח המשויך מוצג כאן. עם לקוח מקושר תוכלו לשמור את ההזמנה ולשתף את קישור ההצעה הפעיל — או לעבור לתשלום בשמו.",
                    "fltCartCreateOrderTitle": "שמירה ושיתוף הצעה",
                    "fltCartCreateOrderDesc": "לחצו על שמור הצעה כשאתם מוכנים — אפשרות זו זמינה רק לאחר שיוך לקוח. השמירה מייצרת קישור הצעה פעיל: כשהלקוח פותח אותו המחירים מתעדכנים אוטומטית והזמינות מתעדכנת בזמן אמת. ניתן גם לשלוח הצעה ללא קישור פעיל אם תרצו.",
                    "fltCartComparePriceTitle": "השוואת מחירים",
                    "fltCartComparePriceDesc": "לחצו כדי להשוות את מחיר הטיסה אצל ספקים נוספים ולמצוא את האפשרות המשתלמת ביותר.",
                    "fltCartTotalTitle": "מחיר כולל",
                    "fltCartTotalDesc": "המחיר הכולל מוצג כאן — כולל כל המוצרים והעמלה שלכם. לאחר שאתם מרוצים מההזמנה, שמרו אותה כהצעה לשיתוף עם הלקוח, או לחצו על המשך לתשלום כדי לעבור לדף ההזמנה.",
                    "fltCartActionTitle": "המשך לתשלום",
                    "fltCartActionDesc": "לחצו על \"המשך לתשלום\" להמשך לדף ההזמנה ומילוי פרטי הנוסעים.",
                    "fltCartSaveOfferActionTitle": "שמרו הצעה כדי לסיים",
                    "fltCartSaveOfferActionDesc": "לחצו על שמור הצעה כדי לייצר קישור הצעה חי ולסיים את השלב. תוכלו לשתף את הקישור עם הלקוח בכל עת — המחיר והזמינות מתעדכנים בזמן אמת.",
                    "fltCheckoutCartTitle": "סיכום הזמנה",
                    "fltCheckoutCartDesc": "החלונית השמאלית מציגה סיכום הטיסה הנבחרת וסכום התשלום הכולל.",
                    "fltCheckoutCustomerInfoTitle": "פרטי לקוח",
                    "fltCheckoutCustomerInfoDesc": "מלאו את הפרטים האישיים של המזמין בחלק זה.",
                    "fltCheckoutFirstNameTitle": "שם פרטי",
                    "fltCheckoutFirstNameDesc": "הזינו את השם הפרטי של המזמין כפי שמופיע בתעודת הזהות או בדרכון.",
                    "fltCheckoutLastNameTitle": "שם משפחה",
                    "fltCheckoutLastNameDesc": "הזינו את שם המשפחה של המזמין כפי שמופיע בתעודת הזהות או בדרכון.",
                    "fltCheckoutPhoneTitle": "מספר טלפון",
                    "fltCheckoutPhoneDesc": "נדרש מספר טלפון תקין לצורך שליחת פרטי האישור למזמין.",
                    "fltCheckoutEmailTitle": "כתובת אימייל",
                    "fltCheckoutEmailDesc": "הזינו כתובת אימייל של המזמין לקבלת אישור ההזמנה והכרטיסים האלקטרוניים.",
                    "fltCheckoutGuestInfoTitle": "פרטי נוסעים",
                    "fltCheckoutGuestInfoDesc": "מלאו שם מלא, מספר דרכון ותאריך לידה של כל נוסע בדיוק כפי שמופיע בדרכונם.",
                    "fltCheckoutTCTitle": "תנאים ואישור",
                    "fltCheckoutTCDesc": "קראו ואשרו את תנאי ההזמנה לפני שליחת הטופס.",
                    "fltCheckoutFormTitle": "פרטי נוסעים",
                    "fltCheckoutFormDesc": "מלאו שם מלא, מספר דרכון ותאריך לידה של כל נוסע בדיוק כפי שמופיע בדרכונם.",
                    "fltCheckoutActionTitle": "שלחו את ההזמנה",
                    "fltCheckoutActionDesc": "לחצו על \"שלח ועבור לתשלום\" לאישור פרטי הנוסעים ומעבר לשלב התשלום.",
                    "abBannerTitle": "לוח הסוכן",
                    "abBannerDesc": "זהו לוח הכלים הייחודי לסוכנים ב-B2C. הוא מופיע בראש הדף ומספק גישה מהירה לניהול לקוחות, הגדרות מחיר, יתרת יהלומים ופרטי חשבון.",
                    "abExchangeTitle": "שערי חליפין",
                    "abExchangeDesc": "שערי המטבע בזמן אמת מוצגים כאן לעיון מהיר בעת הזמנות במטבעות שונים.",
                    "abOnboardingBtnTitle": "מדריך Onboarding",
                    "abOnboardingBtnDesc": "לחיצה על אייקון השאלה פותחת מחדש את מדריך ה-Onboarding — תוכלו לחזור לכל שלב בכל עת.",
                    "abSwitchersTitle": "מצבי עבודה",
                    "abSwitchersDesc": "שני מתגים: מצב סוכן/לקוח — כאשר מצב הסוכן פעיל, אפשרויות העמלה והמחירים ייחודיים לסוכן גלויים. מצב מחיר ברוטו/נטו — החליפו בין הצגת מחיר קמעונאי מלא ומחיר נקי.",
                    "abCustomerSearchTitle": "חיפוש לקוח",
                    "abCustomerSearchDesc": "חפשו לקוח קיים בשם או בפרטים. בחירת לקוח מקשרת אותו להזמנה הנוכחית כך שההזמנה תופיע בחשבונו ותוכל להיות מנוהלת מהבק-אופיס.",
                    "abUpgradePlanTitle": "שדרוג חבילה",
                    "abUpgradePlanDesc": "כפתור זה מופיע כאשר הסוכנות אינה בחבילת PRO. לחיצה עליו פותחת את חלון שדרוג החבילה לגישה לתכונות מתקדמות.",
                    "abDiamondsTitle": "יתרת יהלומים",
                    "abDiamondsDesc": "יתרת הקאשבק שלכם ביהלומים מוצגת כאן. הסכום כולל רווחים מאושרים ורווחים עתידיים צפויים. רחפו על האייקון לפירוט.",
                    "abUserMenuTitle": "החשבון שלכם",
                    "abUserMenuDesc": "לחצו על שמכם לפתיחת תפריט החשבון — צפייה בפרטי הפרופיל, סטטוס חבילת הסוכנות ויציאה מהמערכת. לחצו סיים להשלמת השלב.",
                    "pkgResSearchActionTitle": "חיפוש חבילה",
                    "pkgResSearchActionDesc": "מלאו את פרטי הנסיעה למעלה ולחצו חיפוש כדי לראות חבילות זמינות.",
                    "pkgResOverviewTitle": "תוצאות חיפוש",
                    "pkgResOverviewDesc": "כאן תוכלו לראות את כל החבילות הזמינות התואמות לחיפושכם. כל כרטיסייה מציגה מלון, תאריכי נסיעה, מחיר וטיסות כלולות.",
                    "pkgResSideFiltersTitle": "סינון תוצאות",
                    "pkgResSideFiltersDesc": "השתמשו בפילטרים הצדדיים לצמצום התוצאות לפי מחיר, יעד, דירוג מלון ועוד.",
                    "pkgResCardTitle": "כרטיסיית חבילה",
                    "pkgResCardDesc": "כל כרטיסייה מציגה שם מלון, תאריכי נסיעה, טיסות, תוספות כלולות ומחיר לאדם. לחצו \"להזמנה\" לפתיחת פרטי החבילה המלאים.",
                    "pkgResActionTitle": "פתיחת פרטי החבילה",
                    "pkgResActionDesc": "לחצו \"להזמנה\" בכרטיסיית חבילה כלשהי לפתיחת הפרטים המלאים בלשונית חדשה לבחירת חדר והשלמת ההזמנה.",
                    "pkgPageHotelTitle": "פרטי המלון",
                    "pkgPageHotelDesc": "חלק זה מציג את כל פרטי המלון בחבילה — תמונות, שם, דירוג כוכבים ותאריכי ההזמנה.",
                    "pkgPageGalleryTitle": "תמונות המלון",
                    "pkgPageGalleryDesc": "עיינו בגלריית המלון — לחצו על כל תמונה לפתיחת המציג במסך מלא ולצפייה בכל התמונות.",
                    "pkgPageDetailsTitle": "שם ודירוג המלון",
                    "pkgPageDetailsDesc": "כאן ניתן לראות את שם המלון, היעד, דירוג הכוכבים, תאריכי הנסיעה ואורך השהייה הכולל.",
                    "pkgPageIncludesTitle": "מה כלול בחבילה",
                    "pkgPageIncludesDesc": "אזור זה מפרט את כל מה שכלול במחיר החבילה — טיסות, העברות, פעילויות וכרטיסי אירועים.",
                    "pkgPageFlightsTitle": "פרטי הטיסה",
                    "pkgPageFlightsDesc": "חלק זה מציג את טיסות ההלוך והחזור הכלולות בחבילה — חברת תעופה, שעות ומסלול.",
                    "pkgPageRoomsTitle": "בחירת חדר",
                    "pkgPageRoomsDesc": "להלן כל סוגי החדרים הזמינים לחבילה זו. השוו אפשרויות לפי מחיר, סוג בסיס לינה ומאפייני החדר.",
                    "pkgPageRoomFiltersTitle": "סינון חדרים",
                    "pkgPageRoomFiltersDesc": "השתמשו בפילטרים אלה לצמצום האפשרויות לפי מספר אורחים, סוג בסיס לינה (ארוחת בוקר, חצי-פנסיון, הכל-כלול) או שם החדר.",
                    "pkgPageRoomCardTitle": "כרטיסיית חדר",
                    "pkgPageRoomCardDesc": "כל כרטיסיית חדר מציגה תמונה, שם חדר ומתקנים זמינים. גללו למטה בכרטיסייה לצפייה בכל שורות המחיר.",
                    "pkgPageRoomPriceTitle": "מחיר ובסיס לינה",
                    "pkgPageRoomPriceDesc": "כל שורה מציגה את תוכנית הלינה (ארוחת בוקר, חצי-פנסיון וכו׳), מדיניות ביטול, מה כלול ואת המחיר הכולל. בחרו את האפשרות המתאימה ביותר ללקוח.",
                    "pkgPageAddToCartTitle": "הוספת חדר לעגלה",
                    "pkgPageAddToCartDesc": "לחצו \"הוסף להזמנה\" על החדר שבחרתם להוספת החבילה לעגלה והמשך לתשלום.",
                    "moOrderIdTitle": "מספר הזמנה",
                    "moOrderIdDesc": "מספר ההזמנה שלך מוצג כאן. השתמש בו לזיהוי מהיר של ההזמנה בעת פנייה לתמיכה או מעקב אחריה.",
                    "moCartOverviewTitle": "סיכום הזמנה",
                    "moCartOverviewDesc": "הפאנל השמאלי מציג את סיכום ההזמנה המלא שלך — כל המוצרים שהוזמנו, פירוט מחירים ופעולות זמינות.",
                    "moCartProductsTitle": "מוצרים שהוזמנו",
                    "moCartProductsDesc": "כל פריט בהזמנתך מופיע כאן — פרטי טיסה, סוג חדר, תאריכים ומספר נוסעים. בדוק את כל המוצרים לפני ביצוע שינויים.",
                    "moCartAgentTitle": "אפשרויות סוכן",
                    "moCartAgentDesc": "כסוכן, תוכל לשנות את העמלה שלך על הזמנה זו — הגדר אחוז או סכום קבוע לאדם. השינויים מעדכנים את המחיר הכולל המוצג ללקוח.",
                    "moCartTotalTitle": "סה\"כ הזמנה",
                    "moCartTotalDesc": "סכום התשלום הכולל מוצג בתחתית הסל. בדוק אותו בעיון — הוא משקף את כל המוצרים בתוספת עמלת הסוכן שהוחלה.",
                    "moTitleAreaTitle": "פעולות עמוד",
                    "moTitleAreaDesc": "החלק העליון של הטופס מציג את כותרת הדף. הכפתור \"עבור לתשלום\" מאפשר לך להמשיך לשלב התשלום לאחר עיון ועדכון פרטי ההזמנה.",
                    "moPaymentBtnTitle": "המשך לתשלום",
                    "moPaymentBtnDesc": "לחץ על כפתור זה כאשר פרטי ההזמנה מלאים ונכונים. תועבר לחלק התשלום שבו תוכל לבחור אמצעי תשלום ולהשלים את ההזמנה.",
                    "moFormTitle": "טופס פרטי הזמנה",
                    "moFormDesc": "טופס זה מאפשר לך לעיין ולעדכן את כל פרטי ההזמנה — פרטי לקוח, שמות אורחים, פרטי דרכון ובקשות מיוחדות. מלא את כל השדות הנדרשים לפני המעבר לתשלום."
                },
                "guideExplorer": {
                    "title": "מדריך אינטראקטיבי",
                    "subtitle": "גלה תכונות בקצב שלך",
                    "startBtn": "התחל",
                    "doneLabel": "בוצע",
                    "noSiteTooltip": "דורש אתר מוגדר",
                    "timesCompleted": "פעמים הושלם",
                    "filtersTitle": "סינון"
                },
            },
            "bot": {
                "title": "עוזר הנסיעות של Sky360",
                "newChat": "שיחה חדשה",
                "previewCart": "תצוגה מקדימה של סל הקניות",
                "addingToCart": "מוסיף לעגלה…",
                "blocked": "הצ'אט הזה הושבת.",
                "reconnecting": "מתחבר מחדש…",
                "connectionError": "שגיאת חיבור — מנסה שוב…",
                "emptyState": {
                    "title": "איך אוכל לעזור לתכנן את הטיול שלך?",
                    "subtitle": "שאל אותי על טיסות, מלונות, חבילות או פעילויות."
                },
                "input": {
                    "placeholder": "שאל אותי כל שאלה על הטיול שלך…",
                    "disabled": "הצ'אט מושבת"
                },
                "itinerary": {
                    "titleOne": "פריט אחד · {{total}}",
                    "titleOther": "{{count}} פריטים · {{total}}",
                    "total": "סה\"כ",
                    "remove": "הסר"
                },
                "checkout": {
                    "title": "המסלול שלך",
                    "travellers": "נוסעים",
                    "total": "סה\"כ",
                    "confirmBook": "אשר והזמן",
                    "completeBooking": "להשלמת ההזמנה"
                },
                "result": {
                    "select": "בחר",
                    "direct": "ישיר",
                    "stopsOne": "עצירה אחת",
                    "stopsOther": "{{count}} עצירות",
                    "freeCancellation": "ביטול חינם",
                    "return": "חזרה",
                    "nights": "לילות",
                    "perNight": "/לילה"
                }
            },
            "changeApproval": {
                "greeting": "שלום",
                "subtitle": "חל שינוי בטיסה שלך",
                "changeTableTitle": "פרטי השינוי",
                "colField": "שדה",
                "colBefore": "לפני",
                "colAfter": "אחרי",
                "confirmPrompt": "אנא אשר שהינך מודע לשינוי בהזמנה שלך.",
                "confirmBtn": "מאשר את השינוי",
                "declineBtn": "אני מסרב",
                "expiresLabel": "בתוקף עד",
                "expiresIn": "הקישור פג תוקף בעוד",
                "confirmedTitle": "אישרת את השינוי",
                "confirmedMsg": "אישרת את השינוי ב-",
                "declinedTitle": "דחית את השינוי",
                "declinedMsg": "דחית את השינוי. הצוות שלנו ייצור איתך קשר.",
                "expiredTitle": "הקישור פג תוקף",
                "expiredMsg": "הקישור אינו בתוקף. אנא צור קשר עם שירות הלקוחות.",
                "failedTitle": "הקישור אינו זמין",
                "failedMsg": "הקישור אינו זמין. אנא צור קשר עם שירות הלקוחות.",
                "errorBanner": "אירעה שגיאה. אנא נסה שוב.",
                "loading": "טוען...",
                "days": "ימים",
                "hours": "שעות",
                "minutes": "דקות"
            }
        }
    }
};

export default translationsHe;